<div  *ngIf="showCartData">
  <div class="outside-container mt-4">
    <div class="box-container ">
     <div class="container">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div></div></div>

</div>
<span *ngIf="!showCartData">
<div *ngIf="airData" class="outside-container mt-4">
    <div class="box-container ">
        <div class="container">
            <div class="title ">
              <div class="row">
                <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
               <div class="col-md-7 d-flex justify-content-center">Modify Cart </div>
               <div class=" col-md-3 row ">
                 <div class="d-flex justify-content-end">
                  <button *ngIf="airData.status==='OK'||airData.status==='HP'||airData.status==='CO'||airData.status==='PB'||airData.status==='PC'||airData.status==='CN'" mat-flat-button  style="background-color:#4986E8;color:white; font-size: 17px;"[matMenuTriggerFor]="showDialog"><mat-icon>keyboard_arrow_down</mat-icon>Download Voucher</button>
                    <mat-menu #showDialog="matMenu"  >
                      <button style="width: 180px;" (click)="generatePDF('C')" mat-menu-item><mat-icon>download</mat-icon>Current</button>
                      <button style="width: 180px;" (click)="generatePDF('O')" mat-menu-item><mat-icon>download</mat-icon>Original</button>
    
                      </mat-menu>
                  <!-- <button  class="btn btn-outline-primary btn-sm " (click)="onAddDataEntity()"><img src="assets/images/Add_24.png"></button> -->
                 
               </div>
                </div>
              </div>
            
            </div> 
            </div>
            </div>
          </div>
          <div  *ngIf="airData" class="outside-container ">
            <div class="box-container ">
                <div class="container ">
                  <div class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
                 
                 
                    <div class="col-md-2  "  style="background-color: #d2e1f5; border-radius: 4px; content: right; padding-top: 10px; height:70vh;overflow-y: auto; ">
                      <div class="col-md-12 ">
                        <!-- [ngClass]="{'activity' :showItinerary}" -->
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(clientInfo)"  >Client Information</span></span>
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"    (click)="scroll(cartInfo)"   >Cart Information</span></span>
                      <span *ngIf="airData.invoiceData.length!=0" class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(PartyInfo)"  >3rd Party Invoicing </span></span>
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(notes)"  >Notes</span></span>
                      <span  class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(itineraryInfo)">Booking Details</span></span>

                      <!-- <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(itineraryInfo)"  >Itinerary Information</span></span> -->
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(contactDetails)"  >Contact Details</span></span>
                      <span *ngIf="airData?.hotelItineraries[0]?.payment.length>0" class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(paymentDetails)"  >Payment Details</span></span>
                      <span *ngIf="amendCartList.length!=0" class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(CartAmendments)"  >Cart Amendments</span></span>
                      <span  class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(reportingTags)">Reporting Tags</span></span>
                      <span  class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(whatsapp)">WhatsApp Notifications</span></span>
                      <span  class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(email)">Email Notifications</span></span>
  
                      <!-- *ngIf="airData.amendment" -->
                      
                    </div>
                      
                    </div>
  
                   <div class="col-md-10" style="height:70vh; overflow-y: auto;">
                     <div  class="col-md-12 card" style="min-height: 100%;" >
  
                      <div  class="  mt-1 " style="padding: 10px; padding-bottom: 380px;">
                       
                        <div #clientInfo class="col-md-12 title"style="max-height: 45px;" >
                            Client Information
                        </div>
  
                        <div class="col-md-12 " style="overflow:auto">
                         
                            <table class="styled-Upper-table mt-3" style="margin: 0; padding: 0;width: 100%;">
                            
                                <tbody>
                                  <!-- Iterate through dynamic data rows -->
                                  <tr style="background-color: #f2f2f2;" >
                                    <!-- Display structured data -->
                                   
                                    <td class="name-type" >Client Name	</td>
                                    <td  class="" style="background-color: #ffffff;min-width:300px;">
                                      <!-- Interpret the character and display accordingly -->
                                     {{clientName}}
                              <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                    </td>
                                    <td class="name-type" >Billing Entity	</td>
                                    <td  class="" style="background-color: #ffffff; min-width:300px;">
                                      <!-- Interpret the character and display accordingly -->
                                      {{billingEntity}}                        <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                    </td>
                                    
                                  </tr>
                                 
                                  
                                </tbody>
                              </table>  
                          
                          </div>
                          
                          <div #cartInfo class="col-md-12 title mt-2"style="max-height: 50px;" >
                            Cart Information  
                          </div>
  
                        <div class="col-md-12 " style="overflow:auto">
                         
                            <table class="styled-Upper-table mt-3 " style="margin: 0; padding: 0;width: 100%;">
                            
                                <tbody>
                                  <!-- Iterate through dynamic data rows -->
                                  <tr style="background-color: #f2f2f2;">
                                    <!-- Display structured data -->
                                    <td class="name-type" >Cart Id</td>
                                    <td  class="" style="background-color: #ffffff;min-width:200px;">
                                     {{airData?.uuid||'-'}}
                                    </td>
                                    <td class="name-type" >Request Id</td>
                                    <td  class="" style="background-color: #ffffff;min-width:200px;">
                                     {{airData?.requestUuid||'-'}}
                                    </td></tr>
                                  <tr style="background-color: #f2f2f2;">
                                    <!-- Display structured data -->
                                
                                    <td class="name-type" >Generation Time		</td>
                                    <td  class="" style="background-color: #ffffff;min-width:200px;">
                                      <!-- Interpret the character and display accordingly -->
                                     {{formatDate(airData?.creationTs)||'-'}}
                              <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                    </td>
                                    <td class="name-type" >Booking Status</td>
                                    <td  class="" style="background-color: #ffffff; min-width:200px;">
                                      <!-- Interpret the character and display accordingly -->
                                      <button *ngIf="airData.status==='N'"  disabled style="background-color:#4986E8;color:white;min-width: 130px;" mat-flat-button>NEW</button>
                                      <button *ngIf="airData.status==='PG'"  disabled style="background-color:#4986E8;color:white;min-width: 130px;" mat-flat-button>Pending</button>
                                      <button *ngIf="airData.status==='HP'"  disabled style="background-color:#44D43B;;color:white;min-width: 130px;" mat-flat-button>Pending Hotel Confirmation</button>
                                      <button *ngIf="airData.status==='OK'"  disabled style="background-color:#44D43B;color:white;min-width: 130px;" mat-flat-button>Confirmed</button>
                                      <button *ngIf="airData.status==='CO'"  disabled style="background-color:#1ba511;;color:white;min-width: 130px;" mat-flat-button>Completed</button>
                                      <button *ngIf="airData.status==='PB'"  disabled style="background-color:#FEC000;;color:white;min-width: 130px;" mat-flat-button>PARTIALLY BOOKED</button>
                                      <button  *ngIf="airData.status==='FD'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>FAILED</button>
                                      <button  *ngIf="airData.status==='CN'" style="background-color:#ff6f00;color:white;min-width: 140px;" mat-flat-button>CANCELLED</button>
                                      <button  *ngIf="airData.status==='CR'" style="background-color:#FFA500;color:white;min-width: 140px;" mat-flat-button>Cancellation Requested</button>
                                      <button  *ngIf="airData.status==='PC'" style="background-color:#e69807;color:white;min-width: 140px;" mat-flat-button>Partially Cancelled</button>


                                 
                 

                                    </td>
                                   
                                  </tr>
                                  <tr style="background-color: #f2f2f2; ">
                                    <!-- Display structured data -->
                                    
                                    <td class="name-type" 
                                    >Booked For	</td>
                                    <td  class="" style="background-color: #ffffff; min-width:200px;">
                                      {{airData?.bookedFor||'-'}}  
                                    </td>
                                    <td class="name-type" 
                                    >Booked By	</td>
                                    <td  class="" style="background-color: #ffffff; min-width:200px;">
                                     {{bookedBy||'-'}}  
                                    </td>
                                    
                                  </tr>
                                 
                                </tbody>
                                <tbody>
                                    <tr style="background-color: #f2f2f2; ">
                                        <!-- Display structured data -->
                                        <td class="name-type" >Booking Time	
                                        </td>
                                        <td  class="" style="background-color: #ffffff; min-width:200px;">
                                          <!-- Interpret the character and display accordingly -->
                                         {{formatDate(airData?.bookingTs)||'-'}}                        <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                        </td>
                                          <!-- Display structured data -->
                                          <td class="name-type" >Supplier booking ID
                                          </td>
                                          <td  class="" style="background-color: #ffffff; min-width:200px;">
                                            <div class="row col-md-12">
                                           <div class="col-md-9"> {{splitBookingId(airData?.bookingId)||'-'}}  </div>
                                            <!-- <button *ngIf="showButtons" class="col-md-3" mat-flat-button style="background-color:#4986E8;color:white;"> Update</button> -->
                                          </div>
                                          </td>
                                      
                                      </tr>
  
                                      <tr style="background-color: #f2f2f2; ">
                                        <!-- Display structured data -->
                                        <td class="name-type" >Emulating User		
                                        </td>
                                        <td  class="" style="background-color: #ffffff; min-width:200px;">
                                          <!-- Interpret the character and display accordingly -->
                                         {{''}}                        <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                        </td>
                                        <!-- <td class="name-type" >Reseller User		
                                        </td>
                                        <td  class="" style="background-color: #ffffff; min-width:200px;">
                                          <div class="row col-md-12">
                                            <div class="col-md-9"> {{''}}</div>
                                             <button *ngIf="showButtons" class="col-md-3" (click)="openGstDetail()" mat-flat-button style="background-color:#4986E8;color:white;"> GST&nbsp;Info</button>
                                           </div>
                                        </td> -->
                                        <td class="name-type" >Cart Type				
                                        </td>
                                        <td  class="" style="background-color: #ffffff; min-width:200px;">
                                          {{airData.cartType==='A'?('Auto'):airData.cartType==='M'?('Manual'):''}}
                                        </td>
                                        </tr>
                                        <tr style="background-color: #f2f2f2; ">
                                          <!-- Display structured data -->
                                          <td class="name-type" >Payment Status			
                                          </td>
                                          <td  class="" style="background-color: #ffffff; min-width:200px;">
                                            {{airData?.paymentStatus==='P'?('PAID'):''}}
                                            {{airData?.paymentStatus==='F'?('FAILED'):''}}
                                            {{airData?.paymentStatus==='I'?('INITIATED'):''}}
                                            {{airData?.paymentStatus==='A'?('ABORTED'):''}}
                                            {{airData?.paymentStatus==='U'?('UNPAID'):''}}
  
                                          </td>
                                          <td class="name-type" >External Trip Id				
                                          </td>
                                          <td  class="" style="background-color: #ffffff; min-width:200px;">
                                            <div class="row col-md-12">
                                              <div class="col-md-12"> {{airData.tripId}}</div>
                                               <!--<input type="text" class="form-control" placeholder="dd/mm/yyyy"  > <button *ngIf="showButtons" class="col-md-3" mat-flat-button style="background-color:#4986E8;color:white;"> Update</button> -->
                                             </div>
                                          </td>
                                        </tr>
                                        
  
                                        <tr style="background-color: #f2f2f2; ">
                                          <!-- Display structured data -->
                                          
                                          <td *ngIf="showButtons" class="name-type" >Locked By/Type		
                                          </td>
                                          <td *ngIf="showButtons" class="" style="background-color: #ffffff; min-width:200px;">
                                            <div class="row col-md-12">
                                              <div class="col-md-12"> {{''}}</div>
                                               <button class="col-md-3" mat-flat-button style="background-color:#4986E8;color:white;"> Unlock</button>
                                             </div>
                                          </td>
                                          <td class="name-type" >	
                                            Payment Type
                                          </td>
                                          <td  class="" style="background-color: #ffffff; min-width:200px;">
                                           {{airData?.bookingPaymentType==='S'?('Postpaid'):''}}
                                           {{airData?.bookingPaymentType==='R'?('Prepaid'):''}}
                                          </td>
                                        </tr>
                                        <tr style="background-color: #f2f2f2; ">
                                          <!-- Display structured data -->
                                          <td class="name-type" >Invoice Status			
                                          </td>
                                          <td  class="" style="background-color: #ffffff; min-width:200px;">
                                            {{airData?.invoiceStatus==='N'?('NEW'):''}}
                                            {{airData?.invoiceStatus==='P'?('PENDING'):''}}
                                            {{airData?.invoiceStatus==='S'?('SUCCESS'):''}}
                                          </td>
                                          <td class="name-type" >Source				
                                          </td>
                                          <!-- <td *ngIf="airData.cartType!='M'" class="" style="background-color: #ffffff; min-width:200px;">
                                           <span *ngIf="airData?.hotelItineraries[0]?.hotelDetails?.hotel?.mmtRooms" >{{'MMT'}}</span>
                                           <span *ngIf="airData?.hotelItineraries[0]?.hotelDetails?.hotel?.expediaRooms" > {{'Expedia'}}</span>
                     
                                          </td> -->
                                          <td >
                                            <span style="text-transform:uppercase;">{{airData?.hotelSource}}</span>
                                            <!-- <span *ngIf="airData?.hotelSource==='expedia'" > {{'Expedia'}}</span> -->
                      
                                          </td>
                                        
                                        </tr>
                                        <tr style="background-color: #f2f2f2; ">
                                          <!-- Display structured data -->
                                          <td class="name-type" >Personal Booking			
                                          </td>
                                          <td  class="" style="background-color: #ffffff; min-width:200px;">
                                           {{''}}
                                          </td>
                                          <td class="name-type" >		Supplier		
                                          </td>
                                          <!-- <td *ngIf="airData.cartType!='M'" class="" style="background-color: #ffffff; min-width:200px;">
                                           <span *ngIf="airData?.hotelItineraries[0]?.hotelDetails?.hotel?.mmtRooms" >{{'MMT'}}</span>
                                           <span *ngIf="airData?.hotelItineraries[0]?.hotelDetails?.hotel?.expediaRooms" > {{'Expedia'}}</span>
                     
                                           
                                          </td> -->
                                          <td >
                                            <span style="text-transform: uppercase;" >{{airData?.hotelSupplier}}</span>                      
                                          </td>
                                        
                                        </tr>
                                        <tr style="background-color: #f2f2f2; ">
                                          <!-- Display structured data -->
                                          <td class="name-type" >Guest Booking				
                                          </td>
                                          <td  class="" style="background-color: #ffffff; min-width:200px;">
                                           {{''}}
                                          </td>
                                          <td class="name-type" >Hotel Confirmation number		
                                          </td>
                                          <td  class="" style="background-color: #ffffff; min-width:200px;">
                                           {{airData?.hotelItineraries[0]?.hotelConfirmation?.bookingId}}
                                          </td>
                                        
                                        </tr>
                                        <tr style="background-color: #f2f2f2; ">
                                          <!-- Display structured data -->
                                          <td class="name-type" >Cart Status	
                                                    
                                          </td>
                                          <td  class="name-type" style="background-color: #ffffff; min-width:200px;">
                                            <div class="row col-md-12">
                                              <div  class="col-md-7 pt-1"> {{'Open'}}</div>
                                               <button *ngIf="showButtons" class="col-md-5" mat-flat-button style="background-color:#4986E8;color:white;"> Close</button>
                                             </div>
                                          </td>
                                          <td class="name-type" >				
                                            Booking Platform	
                                          </td>
                                          <td  class="" style="background-color: #ffffff; min-width:200px;">
                                           {{airData?.channel||'-'}}
                                          </td>
                                        
                                        </tr>
                                       
  
                                </tbody>
                              </table>  
                          
                          </div >
                         <span #PartyInfo></span>
                          <div *ngIf="airData.invoiceData.length!=0"  class="col-md-12 title mt-2"style="max-height: 50px;" >
                            3rd Party Invoicing Information</div>
  
                            <div *ngIf="airData.invoiceData.length!=0" class="col-md-12 mt-3" style="overflow:auto" >
                              <table class="styled-tables col-md-12">
                                  <thead>
                                    <tr >
                                      <!-- Dynamic headers based on tableHeaders array -->
                                      <th style="padding: 8px;  text-align: center;">Package Name		</th>
                                      <th style="padding: 8px;  text-align: center;">ID</th>
                                      <th style="padding: 8px;  text-align: center;">Accounts Code	</th>
                                      <th style="padding: 8px;  text-align: center;">Status	</th>
                                      <th style="padding: 8px;  text-align: center;">Failed Attempts	</th>
                                      <th style="padding: 8px;  text-align: center;">Invoice Id	</th>
                                      <th style="padding: 8px;  text-align: center;">Message</th>
                                      <th style="padding: 8px;  text-align: center;">Unique Id	</th>
                                      <th *ngIf="loginUserType==='STAFF'" style="padding: 8px;  text-align: center;">Download Logs</th>
                                      <th *ngIf="loginUserType==='STAFF'" style="padding: 8px;  text-align: center;">Client Invoice</th>
  
  
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <!-- Iterate through dynamic data rows -->
                                    <tr  *ngFor="let invoice of airData.invoiceData;let i=index">
                                      <!-- Display structured data -->
                                      <td  style="padding: 8px;">{{invoice?.packageName}}</td>
                                      <td  style="padding: 8px;">{{invoice?.id}}</td>
                                      <td  style="padding: 8px;">{{invoice?.accountCode}}</td>
                                      <td  style="padding: 8px;">
                                        {{invoice?.invoiceStatus==='N'?('NEW'):''}}
                                        {{invoice?.invoiceStatus==='P'?('PENDING'):''}}
                                        {{invoice?.invoiceStatus==='S'?('SUCCESS'):''}}
                                        <br>
                                        <span *ngIf="invoice.invoiceStatus==='N'&&showButtons">
                                          <mat-icon  style="color: #4986E8; cursor: pointer;" (click)="refresh()">refresh</mat-icon>
  
                                        </span>
                                        <span *ngIf="invoice.invoiceStatus==='P'&&showButtons">
                                        <button *ngIf="!invoice.boolean"  mat-flat-button style="background-color:#4986E8;color:white;" (click)="salesDetail(invoice,i)">Push</button>
                                        <mat-spinner *ngIf="invoice.boolean" style="height:30px;width:30px"></mat-spinner>
  
                                      </span>
  
                                      </td>
                                      <td  style="padding: 8px;">{{invoice?.failedAttempts}}</td>
                                      <td  style="padding: 8px;">{{invoice?.docNo?(invoice?.docPref+'/'+invoice?.docNo):''}}</td>
                                      <td  style="padding: 8px;"></td>
                                      <td  style="padding: 8px;">{{invoice?.uniqueId}}</td>
                                      <td *ngIf="loginUserType==='STAFF'"  style="padding: 8px;"><button mat-flat-button style="background-color:#4986E8;color:white;" (click)="downloadInvoiceLog(invoice)">Download&nbsp;Invoice&nbsp;Log</button></td>
                                      <td *ngIf="loginUserType==='STAFF'"  style="padding: 8px;">
                                        <button *ngIf="!showFinPdF" mat-flat-button style="background-color:#4986E8;color:white;" (click)="downloadFinBookPDF(invoice?.id,invoice?.uniqueId)">Client&nbsp;Invoice</button>
                                        <button *ngIf="showFinPdF&&invoice?.uniqueId===pdfDownloadUrl.uniqueId"  mat-flat-button style="background-color:#4986E8;color:white;min-width: 130px;" >
                                          <mat-spinner  style="height:20px;width:20px"></mat-spinner>
                                        </button>
                                        <button *ngIf="showFinPdF&&invoice?.uniqueId!=pdfDownloadUrl.uniqueId"  mat-flat-button style="background-color:#9bbffa;color:white;min-width: 130px;" >
                                          <!-- <mat-spinner  style="height:20px;width:20px"></mat-spinner> -->
                                          Client&nbsp;Invoice
                                        </button>

                                        </td>
  
                                    </tr>
                                  </tbody>
                                </table>
  
  
                      </div> 
  
                      <div #notes class="col-md-12 title mt-2"style="max-height: 50px;" >
                        Notes</div>
  
                        <div class="col-md-12 mt-3" style="overflow:auto">
                          <table class="styled-tables ">
                              <thead>
                                <tr >
                                  <!-- Dynamic headers based on tableHeaders array -->
                                  <th style="padding: 8px;  text-align: center;">Time		</th>
                                  <th style="padding: 8px;  text-align: center;">Type</th>
                                  <th style="padding: 8px;  text-align: center;">User	</th>
                                  <th style="padding: 8px;  text-align: center;">Private	</th>
                                  <th style="padding: 8px;  text-align: center;">Note	 
                                   <button  class="btn btn-outline-primary btn-sm " (click)="noteOp.toggle($event);blankNotes()"><img src="assets/images/Add_24.png"></button>
                  <p-overlayPanel #noteOp>
                    <div style="padding: 16px; width: 250px;">
                  
                      <div  class="">
                        <mat-form-field appearance="outline" class="w-full">
                          <mat-label>Notes</mat-label>
                          <textarea matInput [(ngModel)]="notesRequest.notes" ></textarea>
                        </mat-form-field>
                        <mat-checkbox color="primary" [(ngModel)]="notesRequest.scop">Scope</mat-checkbox>
  
                      </div>
                    </div>
                  
                    <div class="overlay-footer" style="padding: 10px; border-top: 1px solid #ddd; text-align: right;">
                      <button  class="btn btn-outline-success c-width-100px shadow "  (click)="saveNotes(noteOp)" [disabled]="!notesRequest.notes||disableNotes">Save</button>
  
                      <!-- <button mat-stroked-button color="primary" (click)="saveNotes()">Save</button> -->
                    </div>
                  </p-overlayPanel>
                                  
                                  </th>
                                 
  
  
                                </tr>
                              </thead>
                              <tbody>
                                <!-- Iterate through dynamic data rows -->
                                <tr  *ngFor="let notes of airData.orderNotes">
                                  <!-- Display structured data -->
                                  <td  style="padding: 8px;">{{formatDate(notes?.genTs)}}</td>
                                  <td  style="padding: 8px;">{{notes?.type}}</td>
                                  <td  style="padding: 8px;"></td>
                                  <td  style="padding: 8px;"></td>
                                  <td  style="padding: 8px;">{{notes?.description}}</td>
                                 
  
  
                                </tr>
                              </tbody>
                            </table>
  
  
                  </div> 
                        <span #itineraryInfo></span>
                        <div  class="col-md-12 title mt-2"style="max-height: 50px;" >
                            Booking Details</div>
                        <div class="booking-container" style="text-align: start;">
                            <div class="booking-header">
                                <span class="booking-id">Booking ID: {{airData?.bookingId}}</span>
                                <span class="status on-hold" >
                                  <button *ngIf="showButtons"  mat-flat-button style="background-color:#4986E8;color:white;width: 100%;" (click)="showPopup(airData?.hotelItineraries[0]?.hotelConfirmation)">Update HCN</button>

                                </span>

                            </div>
                            <div class="hotel-info row">
                            <div class="col-md-8">
                                <h2 >{{pnrData?.name}} <span class="stars">
                                   <small *ngFor="let start of starArray(pnrData?.starRating)"> 
                                          <img  src="../../../assets/images/star.png" width="18" height="18" alt="">
                                          </small>
                                </span></h2>
                              
                                <p>{{pnrData?.address}}<br>
                                   {{pnrData?.pinCode?(' Postal Code: '+pnrData?.pinCode):''}}<br>
                                 <br>
                                 <span>{{airData?.hotelItineraries[0]?.hotelConfirmation?.contactPerson?('Hotel Contact Person : '+airData?.hotelItineraries[0]?.hotelConfirmation?.contactPerson):''}}</span><br>
                                 <span>{{airData?.hotelItineraries[0]?.hotelConfirmation?.contactNumber?('Hotel Contact Number : '+airData?.hotelItineraries[0]?.hotelConfirmation?.contactNumber):''}}</span>
                                 <!-- <span>{{airData?.hotelItineraries[0]?.hotelConfirmation?.confirmationDate?('Confirmation Date : '+arrayDateFormate(airData?.hotelItineraries[0]?.hotelConfirmation?.confirmationDate)):''}}</span> -->

                                  <!-- Last Cancellation Date: Mar 14, 2024 9:29 AM -->
                                 </p>
                                </div>
                                <div class="col-md-4">
                                <h4>Fare Summary</h4>


                                <div *ngIf="airData?.hotelItineraries[0]?.hotelDetails?.hotel?.mmtRooms" class="mt-2 row"  style="font-size: 12px; ">
                                  <span class="col-md-8 pt-1">Base Fare</span>
                  
                                  <span class="col-md-4 pb-1 pt-1">
                                    {{airData?.priceData?.totalBaseAmount}} INR
                                    <!-- {{mmtBaseFare(pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.price?.basePrice,pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.price?.couponDiscount,pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.price?.hotelDiscount)||0}}&nbsp;INR -->
                                  </span>
                                  <mat-divider></mat-divider>
                                  <span class="col-md-8 pt-1">Taxes & fees</span>
                        
                                  <span class="col-md-4 pb-1 pt-1">
                                    {{airData?.priceData?.finalTaxes}} INR
                                    <!-- {{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.price?.totalTax||0}}&nbsp;INR -->
                                  </span>
                                  <mat-divider></mat-divider>
                                  <span class="col-md-8 pt-1">MGMT FEE + GST</span>
                    
                                  <span class="col-md-4 pb-1 pt-1">
                                    {{airData?.priceData?.hotelDetailCommercial?.charge?(airData?.priceData?.hotelDetailCommercial?.charge?.toFixed()):0}} + {{airData?.priceData?.hotelDetailCommercial?.tax?(airData?.priceData?.hotelDetailCommercial?.tax?.toFixed()):0}} INR
                                    <!-- {{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.commercial?.charge?(pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.commercial?.charge?.toFixed()):0}} + {{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.commercial?.tax?(pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.commercial?.tax?.toFixed()):0}} INR -->
                                  </span>
                               
                                  <mat-divider style="background-color: #1876D1;"></mat-divider>
                                 <mat-divider></mat-divider>
                                  <span class="col-md-8  pt-1">Total Price</span>
                                  <span class="col-md-4 pb-1 pt-1">
                                    {{airData?.priceData?.totalBookingAmount}} INR
                                    <!-- {{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.totalAmount}} INR -->
                                  </span>
                        
                                </div>
              
                                <div *ngIf="airData?.hotelItineraries[0]?.hotelDetails?.hotel?.expediaRooms" class="mt-2 row"  style="font-size: 12px; ">
                                  <span class="col-md-8 pt-1">Base Fare </span>
                  <span class="col-md-4 pb-1 pt-1">{{airData?.priceData?.totalBaseAmount}} INR</span>
                                  <!-- <span class="col-md-4 pb-1 pt-1">{{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.exclusive?.request_currency?.value?.toFixed()}}&nbsp;{{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.exclusive?.request_currency?.currency||'INR'}}</span> -->
                                   <mat-divider></mat-divider>
                                   <span class="col-md-8 pt-1">Taxes & fees</span>
                        
                                  <span class="col-md-4 pb-1 pt-1" style="white-space: nowrap;">
                                    <!-- {{(pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.inclusive?.request_currency?.value-pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.exclusive?.request_currency?.value)?.toFixed()||0}} &nbsp;{{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.marketing_fee?.request_currency?.currency||'INR'}} -->
                                    {{airData?.priceData?.finalTaxes}} INR
                                    &nbsp;<mat-icon style="cursor: pointer;color:grey;padding-top: 8px;font-size: 18px;" (click)="text.toggle($event)">info</mat-icon></span>
                                  <p-overlayPanel #text [style]="{ width: '30rem' }">
                                    <div class="flex flex-column gap-3 w-25rem">
                                      This charge includes estimated amounts the travel service provider (i.e. hotel, car rental company) pays for their taxes, and/or taxes that we pay, to taxing authorities on your booking (including but not limited to sales, occupancy, and value added tax). This amount may also include any amounts charged to us for resort fees, cleaning fees, and other fees and/or a fee we, the hotel supplier and/or the site you booked on, retain as part of the compensation for our and/or their services, which varies based on factors such as location, the amount, and how you booked.For more details, please see the <a href="https://developer.expediapartnersolutions.com/terms/en" target="_blank"> terms and conditions.</a>
                                      </div>
                                      </p-overlayPanel>
                                  <mat-divider></mat-divider>
                                   <span class="col-md-8 pt-1">property Fee</span>
                        
                                  <span class="col-md-4 pb-1 pt-1">
                                    {{airData?.priceData?.propertyFee}} INR
                                    <!-- {{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.property_fees?.request_currency?.value?.toFixed()||0}}&nbsp;{{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.marketing_fee?.request_currency?.currency||'INR'}} -->
                                  </span>
                                   <mat-divider></mat-divider>
                                   <span class="col-md-8 pt-1">Affiliate Service Charge + GST</span>
                                   <span class="col-md-4 pb-1 pt-1">{{airData?.priceData?.hotelDetailCommercial?.charge?(airData?.priceData?.hotelDetailCommercial?.charge?.toFixed()):0}} + {{airData?.priceData?.hotelDetailCommercial?.tax?(airData?.priceData?.hotelDetailCommercial?.tax?.toFixed()):0}} INR</span>
              
                                   <!-- <span class="col-md-4 pb-1 pt-1">{{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.commercial?.charge?(pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.commercial?.charge?.toFixed()):0}} + {{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.commercial?.tax?(pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.commercial?.tax?.toFixed()):0}} INR</span> -->
                                   <mat-divider style="background-color: #1876D1;"></mat-divider>
                    
                                   <span class="col-md-8 pt-1 bold">Total Price </span>
                                   <span class="col-md-4 pb-1 pt-1 bold">{{airData?.priceData?.totalBookingAmount}} INR</span>
              
                                  <!-- <span class="col-md-4 pb-1 pt-1 bold" >{{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.requestedCurrencyTotalPrice?.toFixed()||0}}&nbsp;INR</span> -->
                                </div>
                                <!-- <div  *ngIf="airData?.hotelItineraries[0]?.hotelDetails?.hotel?.mmtRooms" class="mt-2 row"  style="font-size: 12px; ">
                             
                                  <span class="col-md-8 pt-1">Base Fare</span>
    
                                  <span class="col-md-4 pb-1 pt-1">{{mmtBaseFare(airData?.hotelItineraries[0]?.hotelDetails?.hotel?.mmtRooms[0]?.ratePlans[0]?.price?.basePrice,airData?.hotelItineraries[0]?.hotelDetails?.hotel?.mmtRooms[0]?.ratePlans[0]?.price?.couponDiscount,airData?.hotelItineraries[0]?.hotelDetails.hotel?.mmtRooms[0]?.ratePlans[0]?.price?.hotelDiscount)||0}}&nbsp;INR</span>
                                  <mat-divider></mat-divider>
                                  <span class="col-md-8 pt-1">Taxes & fees</span>
                        
                                  <span class="col-md-4 pb-1 pt-1">{{airData?.hotelItineraries[0]?.hotelDetails?.hotel?.mmtRooms[0]?.ratePlans[0]?.price?.totalTax||0}}&nbsp;INR</span>
                                  <mat-divider></mat-divider>
                                  <span class="col-md-8 pt-1">MGMT FEE + GST</span>
                    
                                  <span class="col-md-4 pb-1 pt-1">{{airData?.hotelItineraries[0]?.hotelDetails?.hotel?.mmtRooms[0]?.ratePlans[0]?.commercial?.charge?(airData?.hotelItineraries[0]?.hotelDetails?.hotel?.mmtRooms[0]?.ratePlans[0]?.commercial?.charge?.toFixed()):0}} + {{airData?.hotelItineraries[0]?.hotelDetails?.hotel?.mmtRooms[0]?.ratePlans[0]?.commercial?.tax?(airData?.hotelItineraries[0]?.hotelDetails?.hotel?.mmtRooms[0]?.ratePlans[0]?.commercial?.tax?.toFixed()):0}} INR</span>
                               
                                  <mat-divider style="background-color: #1876D1;"></mat-divider>
                                  <span class="col-md-8  pt-1">Total Price</span>
                                  <span class="col-md-4 pb-1 pt-1">{{airData?.hotelItineraries[0]?.hotelDetails?.hotel?.mmtRooms[0]?.ratePlans[0]?.totalAmount}} INR</span>
                        
                                </div>
                                <div  *ngIf="airData?.hotelItineraries[0]?.hotelDetails?.hotel?.expediaRooms" class="mt-2 row"  style="font-size: 12px; ">
                             
                                  <span class="col-md-8 pt-1">Base Fare </span>
    
                                  <span class="col-md-4 pb-1 pt-1">{{airData?.hotelItineraries[0].hotelDetails?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.exclusive?.request_currency?.value?.toFixed()}}&nbsp;{{airData?.hotelItineraries[0].hotelDetails?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.exclusive?.request_currency?.currency||'INR'}}</span>
                                   <mat-divider></mat-divider>
                                   <span class="col-md-8 pt-1">Taxes & fees</span>
                        
                                  <span class="col-md-4 pb-1 pt-1" style="white-space: nowrap;">{{(airData?.hotelItineraries[0].hotelDetails?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.inclusive?.request_currency?.value-airData?.hotelItineraries[0].hotelDetails?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.exclusive?.request_currency?.value)?.toFixed()||0}} &nbsp;{{airData?.hotelItineraries[0].hotelDetails?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.marketing_fee?.request_currency?.currency||'INR'}}&nbsp;<mat-icon style="cursor: pointer;color:grey;padding-top: 8px;font-size: 18px;" (click)="text.toggle($event)">info</mat-icon></span>
                                  <p-overlayPanel #text [style]="{ width: '30rem' }">
                                    <div class="flex flex-column gap-3 w-25rem">
                                      This charge includes estimated amounts the travel service provider (i.e. hotel, car rental company) pays for their taxes, and/or taxes that we pay, to taxing authorities on your booking (including but not limited to sales, occupancy, and value added tax). This amount may also include any amounts charged to us for resort fees, cleaning fees, and other fees and/or a fee we, the hotel supplier and/or the site you booked on, retain as part of the compensation for our and/or their services, which varies based on factors such as location, the amount, and how you booked.For more details, please see the <a href="https://developer.expediapartnersolutions.com/terms/en" target="_blank"> terms and conditions.</a>
                                    </div>
                                      </p-overlayPanel>
                                   <mat-divider></mat-divider>
                                   <span class="col-md-8 pt-1">property Fee</span>
                        
                                  <span class="col-md-4 pb-1 pt-1">{{airData?.hotelItineraries[0].hotelDetails?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.property_fees?.request_currency?.value?.toFixed()||0}}&nbsp;{{airData?.hotelItineraries[0].hotelDetails?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.marketing_fee?.request_currency?.currency||'INR'}}</span>
                                   <mat-divider></mat-divider>
                                   <span class="col-md-8 pt-1">Affiliate Service Charge + GST</span>
                    
                                   <span class="col-md-4 pb-1 pt-1">{{airData?.hotelItineraries[0].hotelDetails?.hotel?.expediaRooms[0].rates[0]?.commercial?.charge?(airData?.hotelItineraries[0].hotelDetails?.hotel?.expediaRooms[0].rates[0]?.commercial?.charge?.toFixed()):0}} + {{airData?.hotelItineraries[0].hotelDetails?.hotel?.expediaRooms[0].rates[0]?.commercial?.tax?(airData?.hotelItineraries[0].hotelDetails?.hotel?.expediaRooms[0].rates[0]?.commercial?.tax?.toFixed()):0}} INR</span>
                                   <mat-divider style="background-color: #1876D1;"></mat-divider>
                    
                                   <span class="col-md-8 pt-1 bold">Total Price </span>
                        
                                  <span class="col-md-4 pb-1 pt-1 bold" >{{airData?.hotelItineraries[0].hotelDetails?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.requestedCurrencyTotalPrice?.toFixed()||0}}&nbsp;INR</span>
                               
                                 </div> -->
              
                                </div>
                               
                            </div>
                            <div class="booking-details">
                                <div class="check-in-out">
                                    <div class="check-in">
                                        <span>Check in</span>
                                        <span>{{airData?.hotelBooking?.hotelRequest?.checkInDate}}</span>
                                    </div>
                                    <div class="check-out">
                                        <span>Check out</span>
                                        <span>{{airData?.hotelBooking?.hotelRequest?.checkOutDate}}</span>
                                    </div>
                                    <div class="total-rooms">
                                        <span>Total Rooms</span>
                                        <span>{{airData?.hotelBooking?.hotelRequest?.roomCount}}</span>
                                    </div>
                                    <div class="total-stay">
                                        <span>Total Stay</span>
                                        <span>{{calculateStayNights(airData?.hotelBooking?.hotelRequest?.checkInDate,airData?.hotelBooking?.hotelRequest?.checkOutDate)}} </span>
                                    </div>
                                </div>
              
                                <div class="col-md-12 mt-3" >
                                      
                                  <table class="styled-tables ">
                                      <thead>
                                        <tr >
                                          <!-- Dynamic headers based on tableHeaders array -->
                                          <th style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> hotel</mat-icon>Room Type                                      
                                                <th *ngIf="airData?.hotelItineraries[0]?.hotelDetails?.hotel?.mmtRooms"  style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> restaurant</mat-icon>Meal Plan</th>

                                          <th *ngIf="airData?.hotelItineraries[0]?.hotelDetails?.hotel?.expediaRooms"  style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> restaurant</mat-icon>Services</th>
                                          <th style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> groups</mat-icon>Guest Name  </th>
                                                <!-- <th style="padding: 8px;  text-align: center;"  >Seat Map</th> -->
                                                <th *ngIf="showButtons" style="padding: 8px;  text-align: center;">  
                                                  <div>Action</div>                  
                                                  <mat-checkbox color="primary" [(ngModel)]="selectedALLItineraries" (click)="itineraryAllSelect()"></mat-checkbox>
                                                </th>
                                             <!-- <th *ngIf="showButtons" style="padding: 8px;  text-align: center;">
                                              <mat-icon>update</mat-icon>

                                             </th> -->
                                          <!-- <th *ngIf="!showSeatSelection"  style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" (click)="seatWindow()">Seat Selection </th>
                                          <th *ngIf="showSeatSelection"  style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" > <div class="d-flex justify-content-end">Seat Selection  <mat-spinner class="mt-1"  diameter="15" ></mat-spinner></div></th> -->
              
              
              
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <!-- Iterate through dynamic data rows -->
                                        <ng-container *ngFor="let room of airData?.hotelItineraries;let i=index">

                                        <tr >
                                         
                                          <td *ngIf="room?.hotelDetails?.hotel?.mmtRooms"  style="padding: 8px; text-align: center;">
                                            {{ room?.hotelDetails?.hotel?.mmtRooms[0]?.name  }}
                                          </td>
                                          <td *ngIf="room?.hotelDetails?.hotel?.expediaRooms"  style="padding: 8px; text-align: center;">
                                            {{ room?.hotelDetails?.hotel?.expediaRooms[0]?.room_name  }}
                                          </td>
                                          <td *ngIf="airData?.hotelItineraries[0].hotelDetails?.hotel?.mmtRooms" style="padding: 8px; text-align: center;">
                                            {{ room?.hotelDetails?.hotel?.mmtRooms[0]?.ratePlans[0]?.description }}
                                          </td>
                                          <td *ngIf="airData?.hotelItineraries[0].hotelDetails?.hotel?.expediaRooms" style="padding: 8px; text-align: center;">
                                            <ul style="text-align: start;" >
                                              <!-- style="list-style: none;" -->
                                              <li  *ngFor="let amen of  room?.hotelDetails?.hotel?.expediaRooms[0]?.rates[0].amenities let t = index"  [hidden]=" t >= 2"> 
                                                <!-- <mat-icon style="font-size: 18px;padding-top: 8px;"  *ngIf="amen.name==='Free WiFi'">wifi</mat-icon>
                                                <mat-icon style="font-size: 18px;padding-top: 8px;"  *ngIf="amen.name==='Free self parking'"> local_parking</mat-icon>
                                                <mat-icon style="font-size: 18px;padding-top: 8px;" *ngIf="amen.name==='Breakfast buffet'">free_breakfast</mat-icon>
                                                <mat-icon style="font-size: 18px;padding-top:8px;" *ngIf="amen.name==='Free one-way airport transfer'"> transfer_within_a_station</mat-icon>
                                                <mat-icon style="font-size: 18px;padding-top: 8px;" *ngIf="amen.name==='Free welcome drink'"> local_drink</mat-icon>
                         -->
                                                {{ amen.name }}
                        
                                              </li>
                                              <li style="list-style: none;" *ngIf="room?.hotelDetails?.hotel?.expediaRooms[0]?.rates[0]?.amenities&&room?.hotelDetails?.hotel?.expediaRooms[0]?.rates[0]?.amenities.length>2"><span  class="yes" style="cursor: pointer;" (click)="ameni.toggle($event)">...more</span></li>
                        
                                              <p-overlayPanel #ameni [style]="{ width: '30rem' }">
                                                <li *ngFor="let amen of room?.hotelDetails?.hotel?.expediaRooms[0]?.rates[0].amenities "  > 
                                                  {{ amen.name }}
                                                </li>
                                              </p-overlayPanel>
            
                                              </ul>                                         
                                             </td>
                                          <td style="padding: 8px; text-align: center;">
                                            <div *ngFor="let guest of room.orderPassengerDetails ">
                                              {{ guest?.title}}  {{ guest?.firstName}}  {{ guest?.lastName}} <br>
                                              <!-- {{'Adult'}} -->
                                              {{guest.type==="ADT"?("Adult"):guest.type==="CHD"?("Child"):guest.type==="INF"?("Infant"):''}}
                                              <mat-divider ></mat-divider>
                                            </div>
                                          </td>
                                        <td *ngIf="showButtons" style="padding: 8px;  text-align: center;">
                                          <mat-checkbox *ngIf="room.status==='OK'||room.status==='HP'" color="primary" [(ngModel)]='room.showAction' (click)="itinerarySelect(room)" ></mat-checkbox>
                                         <img *ngIf="room.status==='CN'" src="../../../assets/images/crosss.png" width="30px" alt="">
                                        </td>
                                        <!-- <td  *ngIf="showButtons" style="padding: 8px;  text-align: center;">

                                          <button  mat-flat-button style="background-color:#4986E8;color:white;width: 100%;" (click)="onShowMiscellaneous(cartUuid,room?.uuid,room.orderPassengerDetails)" >Update</button>

                                        </td> -->
                                        </tr>
                                        <tr *ngIf="i < airData?.hotelItineraries.length">
                                          <!-- <td colspan="10" style="text-align: left; padding-left: 4px;font-size: small;color: gray;">{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}</td> -->
                                          <td colspan="5" style="text-align: left; padding-left: 4px; font-size: small;color: gray;"><strong>{{room.supplierPayment?('Supplier Payment:'):''}}</strong>{{displayWEJSON(room.supplierPayment)}}</td>
                                          <!-- <strong>{{passengerDetail?('Fare Detail:'):''}}</strong>{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}<br><strong>{{passengerDetail?.seatMeal?.seatMeal?('Seat Meal:'):''}}</strong>{{displayWEJSON(passengerDetail?.seatMeal?.seatMeal)}}<br> -->
                                        </tr>
                                        </ng-container>
                                        
                                      </tbody>
                                    </table>
                                    <table class="styled-tables " *ngIf="showAction">
                                      <thead>
                                  
                                      </thead>
                                      <tbody>
                                        <!-- Iterate through dynamic data rows -->
    
                                        <tr>
                                          <td class="name-type" style="padding: 8px;width:65%;text-align: left;background-color: #f2f2f2;">Amend Selected Hotel Booking	</td>
                                          <td  style="padding: 8px;width:35%" >
                                            <div class="row col-md-12">
                                            <div class="col-md-6 d-flex justify-content-center">
                                            <div class="col-md-12 ">
                                              <button  mat-flat-button style="background-color:#4986E8;color:white;width: 100%;" (click)="OpenAmend('Cancel',selectedItineraries)">Cancel</button>
    
                                            
                                        </div>
                                      </div>
                                          <div class="col-md-6 ">
                                            <!-- <button  mat-flat-button style="background-color:#4986E8;color:white;width: 100%;" (click)="OpenAmend('Reschedule',flights?.flightDetails?.flightDetailsList[0],lastflight?.toAirport,flights?.orderPassengerDetails[0]?.pnr,selectedPnr,PassengerObject)">Reschedule</button> -->
    
                                          </div>
                                        </div>
                                        
                                            </td>
    
                                        </tr>
                                      </tbody>
                                    </table>
              
                          </div> 
              
                                <div class="room-info" *ngIf="pnrData?.mmtRooms" >
                                  
              
                                  <p class="" *ngIf="pnrData?.mmtRooms[0].metadata.roomSize"><small><mat-icon class="pt-1" > square_foot</mat-icon>&nbsp;{{pnrData?.mmtRooms[0]?.metadata?.roomSize?(pnrData?.mmtRooms[0]?.metadata?.roomSize+"sq.ft"):"" }}</small></p> 
                                  <p class=""  *ngFor="let bed of pnrData?.mmtRooms[0]?.metadata?.beds"><small style="white-space: nowrap;"><mat-icon class="pt-1"> hotel</mat-icon>&nbsp;{{bed.count}}&nbsp;{{bed.type}} </small></p> 
                                  <!-- <p>Standard Room with 1 queen bed - incl.: BREAKFAST<br>
                                       1 Queen Bed - Package Deal</p> -->
                                    <!-- <p>Name: {{hotelRoom?.title}} {{hotelRoom?.firstName}} {{hotelRoom?.lastName}}</p> -->
              
                                  </div>
                                  <div class="room-info" *ngIf="pnrData?.expediaRooms" >

                                    <div class="" *ngIf="pnrData?.expediaRooms[0]?.metadata?.area"><small><mat-icon class="pt-1" > square_foot</mat-icon>&nbsp;{{pnrData?.expediaRooms[0]?.metadata?.area.square_meters?(pnrData?.expediaRooms[0]?.metadata?.area?.square_meters?(pnrData?.expediaRooms[0]?.metadata?.area?.square_meters+'sq.mtr'):pnrData?.expediaRooms[0]?.metadata?.area?.square_feet?(pnrData?.expediaRooms[0]?.metadata?.area?.square_feet+'sq.ft'):''):"" }}</small></div> 
                                    <div class="" *ngIf="pnrData?.expediaRooms[0]?.metadata?.bed_groups[0]?.id"><small><mat-icon class="pt-1"> hotel</mat-icon>&nbsp;{{pnrData?.expediaRooms[0]?.metadata?.bed_groups[0]?.id?(pnrData?.expediaRooms[0]?.metadata?.bed_groups[0]?.id):''}} </small><small style="color: red;">(Bed type not guaranteed)</small></div>

                                </div>
                               
                            </div>
                            <div class="special-requests">
                                <h3>Special request(s)</h3>
                                <!-- Add special requests here -->
                                <ul>
                                  <li *ngFor="let data of specialArray(airData?.specialRequest)">
                                   {{data}}
                                  </li></ul>
                            </div>
                            <div class="contact-details">
                                <h3>Contact Details</h3>
                                <p>Email: {{airData?.email}}<br>
                                   Mobile: {{airData?.contactNumber}}</p>
                            </div>
                            <div *ngIf="airData.cartType!='M'" class="cancellation-policy">
                                <h3>Cancellation Policy</h3>
                                <table >
                                    <thead>
                                        <tr>
                                            <th>Cancellation on or After</th>
                                            <th>Cancellation on or Before</th>
                                            <th>Cancellation Charges/Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody  *ngIf="pnrData?.mmtRooms">
                                      <tr *ngFor="let cancellation of pnrData?.mmtRooms[0].ratePlans[0]?.cancellationPolicy?.penalties">
                                        <!-- <td>{{cancellation?.cancelOnOrAfter}}</td>
                                        <td>{{cancellation?.cancelOnOrBefore}}</td>
                                        <td>{{cancellation?.charges}}</td> -->
                                        <td>{{cancellation?.startDate}}</td>
                                        <td>{{cancellation?.endDate}}</td>
                                        <td>{{cancellationType(cancellation?.penaltyValue,cancellation?.penaltyType)}}</td>
                  
                                      </tr>
                                     
                                    </tbody>
                                    <tbody *ngIf="pnrData.expediaRooms">
                                      <tr *ngFor="let cancellation of pnrData?.expediaRooms[0].rates[0]?.cancel_penalties">
                                        <td>{{dateFormateTime(cancellation?.start)}}</td>
                                        <td>{{dateFormateTime(cancellation?.end)}}</td>
                                        <td *ngIf="cancellation?.amount">{{cancellation?.amount||0}}{{cancellation?.currency||'INR'}}</td>
                                        <td *ngIf="cancellation?.nights">{{cancellation?.nights||0}} Night</td>
                                        <td *ngIf="cancellation?.percent">{{cancellation?.percent||0}} %</td>
                                      </tr>
                                      </tbody>
                                </table>
                                <span>
                                  <small *ngIf="pnrData?.expediaRooms" style="color: green;font-style: italic;">All times are in the local time zone</small>

                                </span>
                                <span *ngIf="pnrData?.mmtRooms">
                                <!-- <small>{{pnrData?.mmtRooms[0].ratePlans[0]?.cancellationPolicy?.cancelPaneltyDesc}}</small> -->
                                <small style="color: green;" *ngFor="let cancellation of cancellationFilter(pnrData?.mmtRooms[0].ratePlans[0]?.cancellationPolicy?.cancelPaneltyDesc)">
                                  {{cancellation}}<br>
                                </small>
                              </span>
                                <!-- <p>*Each booking is applicable of ₹8.20 per room per night non-refundable service fees.<br>
                                   *No Show will attract full cancellation charge unless otherwise specified.<br>
                                   *Early check out will attract full cancellation charge unless otherwise specified.</p> -->
                            </div>
                            <div *ngIf="airData.cartType!='M'" class="booking-notes">
                                <h3>Booking Notes</h3>
                                <h3>Policies<br></h3>
                                
                                
                                <div *ngFor="let policy of pnrData?.mmtPolicies" class="policy-card">
                                  <h5 class="category-title" style="color: rgb(99, 99, 99);">{{ policy?.category }}</h5>
                                  <ul  class="amenity-list">
                                    <li class="amenity-item"  *ngFor="let policyList of policy.policyList">
                                      <i class="amenity-icon fas fa-check"></i>
                                      <span class="amenity-name"> {{ policyList }}</span>
                              
                                     
                                    </li>
                                  </ul>
                                </div>
              
                                  
                            </div>
                        </div>









                          <div  *ngIf="airData && airData.airItineraries.length!=0" class="col-md-12 title mt-2" style="max-height: 50px;" >
                            <div  ><span>{{cityFilter(flights?.flightDetails?.flightDetailsList[0]?.fromAirport)}}</span><span style="padding-left: 5px;"><mat-icon style="font-size: 15px;padding-top: 10px; ">arrow_forward</mat-icon></span><span>{{cityFilter(lastflight?.toAirport)}}</span> <span *ngIf="flights?.flightDetails?.flightDetailsList[0]?.schDepartureTime" style="color: rgb(150, 144, 144);"> {{dateFormate(flights?.flightDetails?.flightDetailsList[0]?.schDepartureTime)}}</span></div>
                                                  </div>
  
                        <div class="col-md-12 row" *ngIf="airData&& airData.airItineraries.length!=0">
  
                            <div class="flights pt-3" *ngFor="let item of flights?.flightDetails?.flightDetailsList">
                                <div class="flight-details">
                                  <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
            
                                   
                                  <div class="carrier-info">
                                    <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                    <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                  </div>
                                </div>
                                <svg class="line" width="1200" height="100" >
                                    
                                    <circle fill="#999" cx="4.5" cy="4.5" r="4.5"></circle>
                                    <text x="59.5" y="15" text-anchor="start" font-size="14"  fill="#000">{{ timeFormate(item?.schDepartureTime) }} {{item?.fromAirport}} {{airPortFilter(item?.fromAirport)}} {{item?.fromTerminal?("Terminal "+item?.fromTerminal):''}}</text>
                                    <text x="59.5" y="50.5" text-anchor="start" font-size="16" fill="#000">⌚ {{ converter(item?.travelDuration) }}</text>
            
                                    <circle fill="#999" cx="4.5" cy="92.5" r="4.5"></circle>
                                    <text x="59.5" y="83.5" text-anchor="start"  font-size="14" fill="#000">{{ timeFormate(item?.schArrivalTime)}} {{item?.toAirport}} {{airPortFilter(item?.toAirport)}} {{item?.toTerminal?("Terminal "+item?.toTerminal):''}}</text>
              
                                    <path stroke="#999" stroke-linecap="square" stroke-dasharray="7" d="M4.5 7v84"></path>
                                  </svg>
                                
  
                                 
                              </div>
                              <div class="col-md-12 mt-3" style="overflow:auto">
                                <table class="styled-tables ">
                                    <thead>
                                      <tr >
                                        <!-- Dynamic headers based on tableHeaders array -->
                                        <th style="padding: 8px;  text-align: center;">Passenger	</th>
                                        <th style="padding: 8px;  text-align: center;">Status
                                          Booking Type</th>
                                        <th style="padding: 8px;  text-align: center;">Airline PNR</th>
                                        <th style="padding: 8px;  text-align: center;">CRS PNR	</th>
                                        <!-- <th style="padding: 8px;  text-align: center;">Passive PNR		</th> -->
  
                                        <th style="padding: 8px;  text-align: center;">Ticket No</th>
                                        <th style="padding: 8px;  text-align: center;">B.Class	</th>
  
                                        <th style="padding: 8px;  text-align: center;">Fare Basis</th>
                                        <th style="padding: 8px;  text-align: center;">Cancellation Fee</th>
                                        <th  style="padding: 8px;  text-align: center;">Select</th>
  
    
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <!-- Iterate through dynamic data rows -->
                                      <ng-container *ngFor="let passengerDetail of flights?.orderPassengerDetails; let i = index">
  
                                      <tr >
                                        <!-- Display structured data -->
                                        <td class="" style="padding: 8px;">{{ passengerDetail?.title }} {{ passengerDetail?.firstName }} {{ passengerDetail?.lastName }}
                                       ({{passengerDetail?.passengerType==='ADT'?('Adult'):''||passengerDetail?.passengerType==='CHD'?('Child'):''||passengerDetail?.passengerType==='CH'?('Child'):''||passengerDetail?.passengerType==='CNN'?('Child'):''||passengerDetail?.passengerType==='INF'?('Infant'):''||passengerDetail?.passengerType==='IN'?('Infant'):''}})</td>
                                       <td  style="padding: 8px;">{{passengerDetail?.pnrStatus||'-'}}</td>
                                       <td class="" style="padding: 8px;"><input type="text" class="col-md-12 form-control" [ngModel]="passengerDetail.providerPnrNumber?(passengerDetail.providerPnrNumber):passengerDetail.pnr"></td>
                                        <td class="name-type" style="padding: 8px;">
                                          <mat-icon *ngIf="!passengerDetail.csrPNR" style="color: #4986E8; cursor: pointer;" (click)="  this.refreshCSR(this.cartUuid)">refresh</mat-icon>
                                          <input *ngIf="passengerDetail.csrPNR" type="text" class="form-control col-md-12" [(ngModel)]="passengerDetail.csrPNR">
                                        </td>
                                        <!-- <td class="name-type" style="padding: 8px;"><input type="text"  class="col-md-12 form-control"></td> -->
  
                                        <td class="name-type" style="padding: 8px;">
                                          <input type="text"  class="col-md-12 form-control" [ngModel]="passengerDetail?.ticketNumber==='0'?(''):passengerDetail?.ticketNumber===0?(''):passengerDetail?.ticketNumber?(passengerDetail?.ticketNumber):''">
                                          <!-- <button mat-flat-button *ngIf="!passengerDetail.ticketNumber" style="color: #4986E8; cursor: pointer;" (click)="  this.refreshCSR(this.cartUuid)">Resyncing</button> -->
  
                                        </td>
                                        <td class="name-type" style="padding: 8px;"><input type="text" class="col-md-12 form-control" [(ngModel)]="passengerDetail.fareDetails.passengerBookingClasses[0].bookingClass"></td>
                                        <td class="" style="padding: 8px;"> <input type="text" class="col-md-12 form-control" [(ngModel)]="passengerDetail.fareDetails.passengerBookingClasses[0].fareBasis"></td>
                                        <td class="name-type" style="padding: 8px;"> <input type="text" class="col-md-12 form-control" ></td>
                                        <td *ngIf="passengerDetail.pnrStatus==='HK'||passengerDetail.pnrStatus==='OK'" class="name-type" style="padding: 8px;">
                                          <mat-checkbox color="primary"[(ngModel)]='passengerDetail.showAction' (click)="itinerarySelect(passengerDetail)"></mat-checkbox>
                                        </td>
  
    
                                      </tr>
  
                                      <tr *ngIf="i < flights?.orderPassengerDetails.length">
                                        <td colspan="10" style="text-align: left; padding-left: 4px; font-size: small;color: gray;"><strong>{{passengerDetail?('Fare Detail:'):''}}</strong>{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}<br><strong>{{passengerDetail?.seatMeal?.seatMeal?('Seat Meal:'):''}}</strong>{{displayWEJSON(passengerDetail?.seatMeal?.seatMeal)}}<br><strong>{{flights.supplierPayment?('Supplier Payment:'):''}}</strong>{{displayWEJSON(flights.supplierPayment)}}</td>
                                        
                                      </tr>
  </ng-container>
                                    
                                    </tbody>
                                  </table>
    
                                  <table class="styled-tables " *ngIf="showAction">
                                    <thead>
                                
                                    </thead>
                                    <tbody>
                                      <!-- Iterate through dynamic data rows -->
  
                                      <tr>
                                        <td class="name-type" style="padding: 8px;width:65%;text-align: left;background-color: #f2f2f2;">Amend Selected Air Items	</td>
                                        <td  style="padding: 8px;width:35%" >
                                          <div class="row col-md-12">
                                          <div class="col-md-6 d-flex justify-content-center">
                                          <div class="col-md-12 ">
                                            <!-- <button  mat-flat-button style="background-color:#4986E8;color:white;width: 100%;" (click)="OpenAmend('Cancel',flights?.flightDetails?.flightDetailsList[0],lastflight?.toAirport,flights?.orderPassengerDetails[0].pnr,selectedItineraries,PassengerObject)">Cancel</button> -->
  
                                          <!-- <mat-select class="form-control" [(ngModel)]="amendSelect" name="amend">
                                         <mat-option class="mat-primary" value="cancel">Cancel</mat-option>
                                         <mat-option class="mat-primary" value="reschedule">Reschedule</mat-option>
                                         
  
                                        </mat-select> -->
                                      </div>
                                    </div>
                                        <div class="col-md-6 ">
                                          <!-- <button  mat-flat-button style="background-color:#4986E8;color:white;width: 100%;" (click)="OpenAmend('Reschedule',flights?.flightDetails?.flightDetailsList[0],lastflight?.toAirport,flights?.orderPassengerDetails[0]?.pnr,selectedPnr,PassengerObject)">Reschedule</button> -->
  
                                        </div>
                                      </div>
                                      
                                          </td>
  
                                      </tr>
                                    </tbody>
                                  </table>
    
                        </div> 
                              <mat-divider *ngIf="airData && airData.airItineraries.length!=0 && returnFlights" class="mt-2 mb-2 "></mat-divider>
                              <div *ngIf="airData && airData.airItineraries.length!=0 && returnFlights" class="col-md-12 title mt-2" style="max-height: 50px;margin-left: 10px;" >
                                <div  ><span>{{cityFilter(returnFlights?.flightDetails?.flightDetailsList[0]?.fromAirport)}}</span><span style="padding-left: 5px;"><mat-icon style="font-size: 15px;padding-top: 10px; ">arrow_forward</mat-icon></span><span>{{cityFilter(returnLastFlight?.toAirport)}}</span> <span *ngIf="returnFlights?.flightDetails?.flightDetailsList[0]?.schDepartureTime" style="color: rgb(150, 144, 144);"> {{dateFormate(returnFlights?.flightDetails?.flightDetailsList[0]?.schDepartureTime)}}</span></div>
  
                             </div>
                              <span *ngIf="returnFlights" >
                              <div  class="flights pt-3" *ngFor="let item of returnFlights?.flightDetails?.flightDetailsList">
                                  <div class="flight-details">
                                    <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
            
                                    <div class="carrier-info">
                                      <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                      <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                    </div>
                                  </div>
                                  <svg class="line" width="1200" height="100" >
                                      
                                      <circle fill="#999" cx="4.5" cy="4.5" r="4.5"></circle>
                                      <text x="59.5" y="15" text-anchor="start" font-size="14"  fill="#000">{{ timeFormate(item?.schDepartureTime) }} {{item?.fromAirport}} {{airPortFilter(item?.fromAirport)}} {{item?.fromTerminal?("Terminal "+item?.fromTerminal):''}}</text>
                                      <text x="59.5" y="50.5" text-anchor="start" font-size="16" fill="#000">⌚ {{ converter(item?.travelDuration) }}</text>
              
                                      <circle fill="#999" cx="4.5" cy="92.5" r="4.5"></circle>
                                      <text x="59.5" y="83.5" text-anchor="start"  font-size="14" fill="#000">{{ timeFormate(item?.schArrivalTime)}} {{item?.toAirport}} {{airPortFilter(item?.toAirport)}} {{item?.toTerminal?("Terminal "+item?.toTerminal):''}}</text>
                
                                      <path stroke="#999" stroke-linecap="square" stroke-dasharray="7" d="M4.5 7v84"></path>
                                    </svg>
                                  
                                </div>
                            
                                <div class="col-md-12 mt-3" style="overflow:auto">
                                    <table class="styled-tables ">
                                        <thead>
                                          <tr >
                                            <!-- Dynamic headers based on tableHeaders array -->
                                            <th style="padding: 8px;  text-align: center;">Passenger	</th>
                                            <th style="padding: 8px;  text-align: center;">Status
                                              Booking Type</th>
                                            <th style="padding: 8px;  text-align: center;">Airline PNR</th>
                                            <th style="padding: 8px;  text-align: center;">CRS PNR	</th>
                                            <!-- <th style="padding: 8px;  text-align: center;">Passive PNR		</th> -->
  
                                            <th style="padding: 8px;  text-align: center;">Ticket No</th>
                                            <th style="padding: 8px;  text-align: center;">B.Class	</th>
      
                                            <th style="padding: 8px;  text-align: center;">Fare Basis</th>
                                            <th style="padding: 8px;  text-align: center;">Cancellation Fee</th>
                                            <th  style="padding: 8px;  text-align: center;">Select</th>
  
        
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <!-- Iterate through dynamic data rows -->
                                          <ng-container *ngFor="let passengerDetail of returnFlights?.orderPassengerDetails; let i=index">
                                          <tr >
                                            <!-- Display structured data -->
                                            <td class="" style="padding: 8px;">{{ passengerDetail?.title }} {{ passengerDetail?.firstName }} {{ passengerDetail?.lastName }}
                                              ({{passengerDetail?.passengerType==='ADT'?('Adult'):''||passengerDetail?.passengerType==='CHD'?('Child'):''||passengerDetail?.passengerType==='CH'?('Child'):''||passengerDetail?.passengerType==='CNN'?('Child'):''||passengerDetail?.passengerType==='INF'?('Infant'):''||passengerDetail?.passengerType==='IN'?('Infant'):''}})</td>
                                              <td class="name-type" style="padding: 8px;">{{passengerDetail?.pnrStatus||'-'}}</td>
                                              <td class="" style="padding: 8px;"><input type="text" class="col-md-12 form-control" [ngModel]="passengerDetail.providerPnrNumber?(passengerDetail.providerPnrNumber):passengerDetail.pnr"></td>
                                               <td class="name-type" style="padding: 8px;">
                                                <mat-icon *ngIf="!passengerDetail.csrPNR" style="color: #4986E8; cursor: pointer;"  (click)="refreshCSR(this.cartUuid)">refresh</mat-icon>
  
                                                <input *ngIf="passengerDetail.csrPNR" type="text" class="form-control col-md-12" [(ngModel)]="passengerDetail.csrPNR"></td>
                                               <!-- <td class="name-type" style="padding: 8px;"><input type="text"  class="col-md-12 form-control"></td> -->
         
                                               <td class="name-type" style="padding: 8px;">
                                                <input type="text"  class="col-md-12 form-control" [ngModel]="passengerDetail?.ticketNumber==='0'?(''):passengerDetail?.ticketNumber===0?(''):passengerDetail?.ticketNumber?(passengerDetail?.ticketNumber):''">
                                                <!-- <button mat-flat-button *ngIf="!passengerDetail.ticketNumber" style="color: #4986E8; cursor: pointer;" (click)="  this.refreshCSR(this.cartUuid)">Resyncing</button> -->
  
                                              </td>
                                               <td class="name-type" style="padding: 8px;"><input type="text" class="col-md-12 form-control" [(ngModel)]="passengerDetail.fareDetails.passengerBookingClasses[0].bookingClass"></td>
                                               <td class="" style="padding: 8px;"> <input type="text" class="col-md-12 form-control" [(ngModel)]="passengerDetail.fareDetails.passengerBookingClasses[0].fareBasis"></td>
                                               <td class="name-type" style="padding: 8px;"> <input type="text" class="col-md-12 form-control" ></td>
                                               <td *ngIf="passengerDetail.pnrStatus==='HK'||passengerDetail.pnrStatus==='OK'" class="name-type" style="padding: 8px;">
                                                <mat-checkbox color="primary"[(ngModel)]='passengerDetail.showRAction' (click)="itineraryRSelect(passengerDetail)"></mat-checkbox>
                                              </td>
        
                                          </tr>
                                          <tr *ngIf="i < returnFlights?.orderPassengerDetails.length">
                                            <!-- <td colspan="10" style="text-align: left; padding-left: 4px;font-size: small;color: gray;">{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}</td> -->
                                            <td colspan="10" style="text-align: left; padding-left: 4px; font-size: small;color: gray;"><strong>{{passengerDetail?('Fare Detail:'):''}}</strong>{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}<br><strong>{{passengerDetail?.seatMeal?.seatMeal?('Seat Meal:'):''}}</strong>{{displayWEJSON(passengerDetail?.seatMeal?.seatMeal)}}<br><strong>{{returnFlights.supplierPayment?('Supplier Payment:'):''}}</strong>{{displayWEJSON(returnFlights.supplierPayment)}}</td>
  
                                          </tr>
                                        </ng-container>
                                        </tbody>
                                      </table>
                                      <table class="styled-tables "  *ngIf="showRAction">
                                        <thead>
                                    
                                        </thead>
                                        <tbody>
                                          <!-- Iterate through dynamic data rows -->
      
                                          <tr>
                                            <td class="name-type" style="padding: 8px;width:65%;text-align: left;background-color: #f2f2f2;">Amend Selected Air Items	</td>
                                            <td  style="padding: 8px;width:35%">
                                              <div class="row col-md-12">
  
                                              <div class="col-md-6 d-flex justify-content-center">
                                                <div class="col-md-12 ">
                                                <!-- <mat-select class="form-control" [(ngModel)]="amendRSelect" name="amendR">
                                               <mat-option class="mat-primary" value="cancel">Cancel</mat-option>
                                               <mat-option class="mat-primary" value="reschedule">Reschedule</mat-option>
        
                                              </mat-select> -->
                                              <!-- <button  mat-flat-button style="background-color:#4986E8;color:white;width: 100%;" (click)="OpenAmend('Cancel',returnFlights?.flightDetails?.flightDetailsList[0],returnLastFlight?.toAirport,returnFlights?.orderPassengerDetails[0]?.pnr,selectedRPnr,PassengerRObject)">Cancel</button> -->
  
                                            </div>
                                          </div>
                                              <div class="col-md-6 ">
                                                <!-- <button  mat-flat-button style="background-color:#4986E8;color:white;width: 100%;" (click)="OpenAmend('Reschedule',returnFlights?.flightDetails?.flightDetailsList[0],returnLastFlight?.toAirport,returnFlights?.orderPassengerDetails[0]?.pnr,selectedRPnr,PassengerRObject)">Reschedule</button> -->
        
                                              </div>
                                              </div>
                                            </td>
      
                                          </tr>
                                        </tbody>
                                      </table>
        
        
                            </div> 
                            </span>
                          
        <!--+++++++++++++++++++++++++++++++++++++ Third Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
        <!--+++++++++++++++++++++++++++++++++++++ Third Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
        <!--+++++++++++++++++++++++++++++++++++++ Third Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
        <!--+++++++++++++++++++++++++++++++++++++ Third Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
        <!--+++++++++++++++++++++++++++++++++++++ Third Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
  
  
        <mat-divider *ngIf="airData && airData.airItineraries.length!=0 && thirdFlights" class="mt-2 mb-2 "></mat-divider>
  
        <div *ngIf="airData && airData.airItineraries.length!=0 && thirdFlights" class="col-md-12 title mt-2" style="max-height: 50px;margin-left: 10px;" >
  
          <div  ><span>{{cityFilter(thirdFlights?.flightDetails?.flightDetailsList[0]?.fromAirport)}}</span><span style="padding-left: 5px;"><mat-icon style="font-size: 15px;padding-top: 10px; ">arrow_forward</mat-icon></span><span>{{cityFilter(thirdLastFlight?.toAirport)}}</span> <span *ngIf="thirdFlights?.flightDetails?.flightDetailsList[0]?.schDepartureTime" style="color: rgb(150, 144, 144);"> {{dateFormate(thirdFlights?.flightDetails?.flightDetailsList[0]?.schDepartureTime)}}</span></div>
  
       </div>
        <span *ngIf="thirdFlights" >
        <div  class="flights pt-3" *ngFor="let item of thirdFlights?.flightDetails?.flightDetailsList">
            <div class="flight-details">
              <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
  
              <div class="carrier-info">
                <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
              </div>
            </div>
            <svg class="line" width="1200" height="100" >
                
                <circle fill="#999" cx="4.5" cy="4.5" r="4.5"></circle>
                <text x="59.5" y="15" text-anchor="start" font-size="14"  fill="#000">{{ timeFormate(item?.schDepartureTime) }} {{item?.fromAirport}} {{airPortFilter(item?.fromAirport)}} {{item?.fromTerminal?("Terminal "+item?.fromTerminal):''}}</text>
                <text x="59.5" y="50.5" text-anchor="start" font-size="16" fill="#000">⌚ {{ converter(item?.travelDuration) }}</text>
  
                <circle fill="#999" cx="4.5" cy="92.5" r="4.5"></circle>
                <text x="59.5" y="83.5" text-anchor="start"  font-size="14" fill="#000">{{ timeFormate(item?.schArrivalTime)}} {{item?.toAirport}} {{airPortFilter(item?.toAirport)}} {{item?.toTerminal?("Terminal "+item?.toTerminal):''}}</text>
  
                <path stroke="#999" stroke-linecap="square" stroke-dasharray="7" d="M4.5 7v84"></path>
              </svg>
            
          </div>
      
          <div class="col-md-12 mt-3" style="overflow:auto">
              <table class="styled-tables ">
                  <thead>
                    <tr >
                      <!-- Dynamic headers based on tableHeaders array -->
                      <th style="padding: 8px;  text-align: center;">Passenger	</th>
                      <th style="padding: 8px;  text-align: center;">Status
                        Booking Type</th>
                      <th style="padding: 8px;  text-align: center;">Airline PNR</th>
                      <th style="padding: 8px;  text-align: center;">CRS PNR	</th>
                      <!-- <th style="padding: 8px;  text-align: center;">Passive PNR		</th> -->
  
                      <th style="padding: 8px;  text-align: center;">Ticket No</th>
                      <th style="padding: 8px;  text-align: center;">B.Class	</th>
  
                      <th style="padding: 8px;  text-align: center;">Fare Basis</th>
                      <th style="padding: 8px;  text-align: center;">Cancellation Fee</th>
                      <th  style="padding: 8px;  text-align: center;">Select</th>
  
  
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let passengerDetail of thirdFlights?.orderPassengerDetails;let i=index">
                    <!-- Iterate through dynamic data rows -->
                    <tr >
                      <!-- Display structured data -->
                      <td class="" style="padding: 8px;">{{ passengerDetail?.title }} {{ passengerDetail?.firstName }} {{ passengerDetail?.lastName }}
                        ({{passengerDetail?.passengerType==='ADT'?('Adult'):''||passengerDetail?.passengerType==='CHD'?('Child'):''||passengerDetail?.passengerType==='CH'?('Child'):''||passengerDetail?.passengerType==='CNN'?('Child'):''||passengerDetail?.passengerType==='INF'?('Infant'):''||passengerDetail?.passengerType==='IN'?('Infant'):''}})</td>
                        <td class="name-type" style="padding: 8px;">{{passengerDetail?.pnrStatus||'-'}}</td>
                        <td class="" style="padding: 8px;"><input type="text" class="col-md-12 form-control" [ngModel]="passengerDetail.providerPnrNumber?(passengerDetail.providerPnrNumber):passengerDetail.pnr"></td>
                         <td class="name-type" style="padding: 8px;">
                          <mat-icon *ngIf="!passengerDetail.csrPNR" style="color: #4986E8; cursor: pointer;" (click)="refreshCSR(this.cartUuid)">refresh</mat-icon>
  
                          <input *ngIf="passengerDetail.csrPNR" type="text" class="form-control col-md-12" [(ngModel)]="passengerDetail.csrPNR"></td>
                         <!-- <td class="name-type" style="padding: 8px;"><input type="text"  class="col-md-12 form-control"></td> -->
  
                         <td class="name-type" style="padding: 8px;">
                          <input type="text"  class="col-md-12 form-control" [ngModel]="passengerDetail?.ticketNumber==='0'?(''):passengerDetail?.ticketNumber===0?(''):passengerDetail?.ticketNumber?(passengerDetail?.ticketNumber):''">
                          <!-- <button mat-flat-button *ngIf="!passengerDetail.ticketNumber" style="color: #4986E8; cursor: pointer;" (click)="  this.refreshCSR(this.cartUuid)">Resyncing</button> -->
  
                        </td>
                         <td class="name-type" style="padding: 8px;"><input type="text" class="col-md-12 form-control" [(ngModel)]="passengerDetail.fareDetails.passengerBookingClasses[0].bookingClass"></td>
                         <td class="" style="padding: 8px;"> <input type="text" class="col-md-12 form-control" [(ngModel)]="passengerDetail.fareDetails.passengerBookingClasses[0].fareBasis"></td>
                         <td class="name-type" style="padding: 8px;"> <input type="text" class="col-md-12 form-control" ></td>
                         <td *ngIf="passengerDetail.pnrStatus==='HK'||passengerDetail.pnrStatus==='OK'" class="name-type" style="padding: 8px;">
                          <mat-checkbox color="primary"[(ngModel)]='passengerDetail.showTAction' (click)="itineraryTSelect(passengerDetail)"></mat-checkbox>
                        </td>
  
                    </tr>
                 
                    <tr *ngIf="i < thirdFlights?.orderPassengerDetails.length">
                      <!-- <td colspan="10" style="text-align: left; padding-left: 4px;font-size: small;color: gray;">{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}</td> -->
                      <td colspan="10" style="text-align: left; padding-left: 4px; font-size: small;color: gray;"><strong>{{passengerDetail?('Fare Detail:'):''}}</strong>{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}<br><strong>{{passengerDetail?.seatMeal?.seatMeal?('Seat Meal:'):''}}</strong>{{displayWEJSON(passengerDetail?.seatMeal?.seatMeal)}}<br><strong>{{thirdFlights.supplierPayment?('Supplier Payment:'):''}}</strong>{{displayWEJSON(thirdFlights.supplierPayment)}}</td>
  
                    </tr>
                  </ng-container>
                  </tbody>
                </table>
                <table class="styled-tables "  *ngIf="showTAction">
                  <thead>
              
                  </thead>
                  <tbody>
                    <!-- Iterate through dynamic data rows -->
  
                    <tr>
                      <td class="name-type" style="padding: 8px;width:65%;text-align: left;background-color: #f2f2f2;">Amend Selected Air Items	</td>
                      <td  style="padding: 8px;width:35%">
                        <div class="row col-md-12">
  
                        <div class="col-md-6 d-flex justify-content-center">
                          <div class="col-md-12 ">
                          <!-- <mat-select class="form-control" [(ngModel)]="amendRSelect" name="amendR">
                         <mat-option class="mat-primary" value="cancel">Cancel</mat-option>
                         <mat-option class="mat-primary" value="reschedule">Reschedule</mat-option>
  
                        </mat-select> -->
                        <!-- <button  mat-flat-button style="background-color:#4986E8;color:white;width: 100%;" (click)="OpenAmend('Cancel',thirdFlights?.flightDetails?.flightDetailsList[0],thirdLastFlight?.toAirport,thirdFlights?.orderPassengerDetails[0]?.pnr,selectedTPnr,PassengerTObject)">Cancel</button> -->
  
                      </div>
                    </div>
                        <div class="col-md-6 ">
                          <!-- <button  mat-flat-button style="background-color:#4986E8;color:white;width: 100%;" (click)="OpenAmend('Reschedule',thirdFlights?.flightDetails?.flightDetailsList[0],thirdLastFlight?.toAirport,thirdFlights?.orderPassengerDetails[0]?.pnr,selectedTPnr,PassengerTObject)">Reschedule</button> -->
  
                        </div>
                        </div>
                      </td>
  
                    </tr>
                  </tbody>
                </table>
  
  
      </div> 
      </span>
  
  
   <!--+++++++++++++++++++++++++++++++++++++ Fourth Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
        <!--+++++++++++++++++++++++++++++++++++++ Fourth Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
        <!--+++++++++++++++++++++++++++++++++++++ Fourth Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
        <!--+++++++++++++++++++++++++++++++++++++ Fourth Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
        <!--+++++++++++++++++++++++++++++++++++++ Fourth Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
  
  
        <mat-divider *ngIf="airData && airData.airItineraries.length!=0 && fourthFlights" class="mt-2 mb-2 "></mat-divider>
  
        <div *ngIf="airData && airData.airItineraries.length!=0 && fourthFlights" class="col-md-12 title mt-2" style="max-height: 50px;margin-left: 10px;" >
  
          <div  ><span>{{cityFilter(fourthFlights?.flightDetails?.flightDetailsList[0]?.fromAirport)}}</span><span style="padding-left: 5px;"><mat-icon style="font-size: 15px;padding-top: 10px; ">arrow_forward</mat-icon></span><span>{{cityFilter(fourthLastFlight?.toAirport)}}</span> <span *ngIf="fourthFlights?.flightDetails?.flightDetailsList[0]?.schDepartureTime" style="color: rgb(150, 144, 144);"> {{dateFormate(fourthFlights?.flightDetails?.flightDetailsList[0]?.schDepartureTime)}}</span></div>
  
       </div>
        <span *ngIf="fourthFlights" >
        <div  class="flights pt-3" *ngFor="let item of fourthFlights?.flightDetails?.flightDetailsList">
            <div class="flight-details">
              <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
  
              <div class="carrier-info">
                <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
              </div>
            </div>
            <svg class="line" width="1200" height="100" >
                
                <circle fill="#999" cx="4.5" cy="4.5" r="4.5"></circle>
                <text x="59.5" y="15" text-anchor="start" font-size="14"  fill="#000">{{ timeFormate(item?.schDepartureTime) }} {{item?.fromAirport}} {{airPortFilter(item?.fromAirport)}} {{item?.fromTerminal?("Terminal "+item?.fromTerminal):''}}</text>
                <text x="59.5" y="50.5" text-anchor="start" font-size="16" fill="#000">⌚ {{ converter(item?.travelDuration) }}</text>
  
                <circle fill="#999" cx="4.5" cy="92.5" r="4.5"></circle>
                <text x="59.5" y="83.5" text-anchor="start"  font-size="14" fill="#000">{{ timeFormate(item?.schArrivalTime)}} {{item?.toAirport}} {{airPortFilter(item?.toAirport)}} {{item?.toTerminal?("Terminal "+item?.toTerminal):''}}</text>
  
                <path stroke="#999" stroke-linecap="square" stroke-dasharray="7" d="M4.5 7v84"></path>
              </svg>
            
          </div>
      
          <div class="col-md-12 mt-3" style="overflow:auto">
              <table class="styled-tables ">
                  <thead>
                    <tr >
                      <!-- Dynamic headers based on tableHeaders array -->
                      <th style="padding: 8px;  text-align: center;">Passenger	</th>
                      <th style="padding: 8px;  text-align: center;">Status
                        Booking Type</th>
                      <th style="padding: 8px;  text-align: center;">Airline PNR</th>
                      <th style="padding: 8px;  text-align: center;">CRS PNR	</th>
                      <!-- <th style="padding: 8px;  text-align: center;">Passive PNR		</th> -->
  
                      <th style="padding: 8px;  text-align: center;">Ticket No</th>
                      <th style="padding: 8px;  text-align: center;">B.Class	</th>
  
                      <th style="padding: 8px;  text-align: center;">Fare Basis</th>
                      <th style="padding: 8px;  text-align: center;">Cancellation Fee</th>
                      <th  style="padding: 8px;  text-align: center;">Select</th>
  
  
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let passengerDetail of fourthFlights?.orderPassengerDetails;let i=index">
                    <!-- Iterate through dynamic data rows -->
                    <tr >
                      <!-- Display structured data -->
                      <td class="" style="padding: 8px;">{{ passengerDetail?.title }} {{ passengerDetail?.firstName }} {{ passengerDetail?.lastName }}
                        ({{passengerDetail?.passengerType==='ADT'?('Adult'):''||passengerDetail?.passengerType==='CHD'?('Child'):''||passengerDetail?.passengerType==='CH'?('Child'):''||passengerDetail?.passengerType==='CNN'?('Child'):''||passengerDetail?.passengerType==='INF'?('Infant'):''||passengerDetail?.passengerType==='IN'?('Infant'):''}})</td>
                        <td class="name-type" style="padding: 8px;">{{passengerDetail?.pnrStatus||'-'}}</td>
                        <td class="" style="padding: 8px;"><input type="text" class="col-md-12 form-control" [ngModel]="passengerDetail.providerPnrNumber?(passengerDetail.providerPnrNumber):passengerDetail.pnr"></td>
                         <td class="name-type" style="padding: 8px;">
                          <mat-icon *ngIf="!passengerDetail.csrPNR" style="color: #4986E8; cursor: pointer;" (click)="refreshCSR(this.cartUuid)">refresh</mat-icon>
  
                          <input *ngIf="passengerDetail.csrPNR" type="text" class="form-control col-md-12" [(ngModel)]="passengerDetail.csrPNR"></td>
                         <!-- <td class="name-type" style="padding: 8px;"><input type="text"  class="col-md-12 form-control"></td> -->
  
                         <td class="name-type" style="padding: 8px;">
                          <input type="text"  class="col-md-12 form-control" [ngModel]="passengerDetail?.ticketNumber==='0'?(''):passengerDetail?.ticketNumber===0?(''):passengerDetail?.ticketNumber?(passengerDetail?.ticketNumber):''">
                          <!-- <button mat-flat-button *ngIf="!passengerDetail.ticketNumber" style="color: #4986E8; cursor: pointer;" (click)="  this.refreshCSR(this.cartUuid)">Resyncing</button> -->
  
                        </td>
                         <td class="name-type" style="padding: 8px;"><input type="text" class="col-md-12 form-control" [(ngModel)]="passengerDetail.fareDetails.passengerBookingClasses[0].bookingClass"></td>
                         <td class="" style="padding: 8px;"> <input type="text" class="col-md-12 form-control" [(ngModel)]="passengerDetail.fareDetails.passengerBookingClasses[0].fareBasis"></td>
                         <td class="name-type" style="padding: 8px;"> <input type="text" class="col-md-12 form-control" ></td>
                         <td *ngIf="passengerDetail.pnrStatus==='HK'||passengerDetail.pnrStatus==='OK'" class="name-type" style="padding: 8px;">
                          <mat-checkbox color="primary"[(ngModel)]='passengerDetail.showFAction' (click)="itineraryFSelect(passengerDetail)"></mat-checkbox>
                        </td>
  
                    </tr>
                    <tr *ngIf="i < fourthFlights?.orderPassengerDetails.length">
                      <!-- <td colspan="10" style="text-align: left; padding-left: 4px;font-size: small;color: gray;">{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}</td> -->
                      <td colspan="10" style="text-align: left; padding-left: 4px; font-size: small;color: gray;"><strong>{{passengerDetail?('Fare Detail:'):''}}</strong>{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}<br><strong>{{passengerDetail?.seatMeal?.seatMeal?('Seat Meal:'):''}}</strong>{{displayWEJSON(passengerDetail?.seatMeal?.seatMeal)}}<br><strong>{{fourthFlights.supplierPayment?('Supplier Payment:'):''}}</strong>{{displayWEJSON(fourthFlights.supplierPayment)}}</td>
  
                    </tr>
                  </ng-container>
                   
                  </tbody>
                </table>
                <table class="styled-tables "  *ngIf="showFAction">
                  <thead>
              
                  </thead>
                  <tbody>
                    <!-- Iterate through dynamic data rows -->
  
                    <tr>
                      <td class="name-type" style="padding: 8px;width:65%;text-align: left;background-color: #f2f2f2;">Amend Selected Air Items	</td>
                      <td  style="padding: 8px;width:35%">
                        <div class="row col-md-12">
  
                        <div class="col-md-6 d-flex justify-content-center">
                          <div class="col-md-12 ">
                          <!-- <mat-select class="form-control" [(ngModel)]="amendRSelect" name="amendR">
                         <mat-option class="mat-primary" value="cancel">Cancel</mat-option>
                         <mat-option class="mat-primary" value="reschedule">Reschedule</mat-option>
  
                        </mat-select> -->
                        <!-- <button  mat-flat-button style="background-color:#4986E8;color:white;width: 100%;" (click)="OpenAmend('Cancel',fourthFlights?.flightDetails?.flightDetailsList[0],fourthLastFlight?.toAirport,fourthFlights?.orderPassengerDetails[0]?.pnr,selectedFPnr,PassengerFObject)">Cancel</button> -->
  
                      </div>
                    </div>
                        <div class="col-md-6 ">
                          <!-- <button  mat-flat-button style="background-color:#4986E8;color:white;width: 100%;" (click)="OpenAmend('Reschedule',fourthFlights?.flightDetails?.flightDetailsList[0],fourthLastFlight?.toAirport,fourthFlights?.orderPassengerDetails[0]?.pnr,selectedFPnr,PassengerFObject)">Reschedule</button> -->
  
                        </div>
                        </div>
                      </td>
  
                    </tr>
                  </tbody>
                </table>
  
  
      </div> 
      </span>
  
                          
                          </div>
                    
                         
  
                          <div #contactDetails class="col-md-12 title mt-2"style="max-height: 50px;" >
                            Passenger Contact Details</div>
  
                            <div class="col-md-12 mt-3" >
                              <table class="styled-tables ">
                                  <thead>
                                    <tr >
                                      <!-- Dynamic headers based on tableHeaders array -->
                                      <th style="padding: 8px;  text-align: center;">Mobile		</th>
                                      <th style="padding: 8px;  text-align: center;">Email Address		</th>
                                      <th style="padding: 8px;  text-align: center;">Postal Address		</th>
                                      <th *ngIf="showButtons" style="padding: 8px;  text-align: center;">Send Details</th>
                                      
  
  
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <!-- Iterate through dynamic data rows -->
                                    <tr >
                                      <!-- Display structured data -->
                                      <td  style="padding: 8px;">{{airData?.contactNumber}}</td>
                                      <td  style="padding: 8px;">{{airData?.email}}</td>
                                      <td style="padding: 8px;"></td>
                                      <td *ngIf="showButtons" style="padding: 8px;">
                                        <!-- <button mat-flat-button style="background-color:#4986E8;color:white;margin-right: 6px;">SMS</button> -->
                                        <button mat-flat-button style="background-color:#4986E8;color:white;margin-right: 6px;" (click)="whatsApp(airData?.contactNumber)">WhatsApp</button>
                                        <button mat-flat-button style="background-color:#4986E8;color:white;" (click)="emailSend(airData?.email)">Email</button>
                                      </td>
                                     
  
  
                                    </tr>
                                  </tbody>
                                </table>
  
  
                      </div> 
                      <!--  -->
                    <span #paymentDetails></span>
                      <div   *ngIf="airData?.hotelItineraries[0]?.payment.length>0"
                      class="col-md-12 title mt-2"style="max-height: 50px;" >
                        Payment Details
                      </div>
  
                        <div *ngIf="airData?.hotelItineraries[0]?.payment.length>0" class="col-md-12 mt-3" style="overflow:auto">
                          <div *ngFor="let payments of airData.hotelItineraries; let i=index">
                            <div class="d-flex justify-content-start bold">Room - {{i+1}}</div>
                           <table class="styled-tables col-md-12">
                               <thead>
                                 <tr >
                                   <!-- Dynamic headers based on tableHeaders array -->
                                   <th style="padding: 8px;  text-align: center;">Payment Id			</th>
                                   <th style="padding: 8px;  text-align: center;">Payment Time	</th>
                                   <th style="padding: 8px;  text-align: center;">Reason		</th>
                                   <th style="padding: 8px;  text-align: center;">Medium		</th>	
                                   <th style="padding: 8px;  text-align: center;">Operation	</th>
                                   <th style="padding: 8px;  text-align: center;">Amend Id	</th>
                                   <th style="padding: 8px;  text-align: center;">Amount		</th>
                                   <th style="padding: 8px;  text-align: center;">GST			</th>
                                   <th style="padding: 8px;  text-align: center;">TDS Amount			</th>
                                   <th style="padding: 8px;  text-align: center;">Status			</th>
                                   <th style="padding: 8px;  text-align: center;">Adhoc Refund				</th>
                                   <!-- <th style="padding: 8px;  text-align: center;">Payment Receipt</th> -->
   
   
   
                                 </tr>
                               </thead>
                               <tbody>
                                 <!-- Iterate through dynamic data rows -->
                                 <tr *ngFor="let payment of payments.payment">
                                   <!-- Display structured data -->
                                   <td  style="padding: 8px;">{{payment?.uuid}}</td>
                                   <td  style="padding: 8px;">{{formatDate(payment?.creationTs)}}</td>
                                   <td  style="padding: 8px;">{{payment?.reason}}</td>
                                   <td  style="padding: 8px;" style="  text-transform:capitalize;">{{payment?.medium}}</td>
                                   <td  style="padding: 8px;">{{payment?.operation}}</td>
                                   <td  style="padding: 8px;">{{payment?.amendmentId}}</td>
                                   <td  style="padding: 8px;">{{payment?.amount}}&nbsp;INR</td>
                                   <td  style="padding: 8px;">{{payment?.gstAmount}}&nbsp;INR</td>
                                   <td  style="padding: 8px;">{{payment?.tdsAmount}}&nbsp;INR</td>
                                   <td  style="padding: 8px;">{{payment?.status}}</td>
                                   <td  style="padding: 8px;">{{''}}</td>
                                   <!-- <td  style="padding: 8px;"><button mat-flat-button style="background-color:#4986E8;color:white;">Receipt</button></td> -->
   
   
                                 </tr>
                               </tbody>
                             </table>
                           </div>
  
  
                  </div> 
  
                  <span #CartAmendments></span>
                  <!-- *ngIf="airData.amendment" -->
                  <div   *ngIf="amendCartList.length!=0"
                  class="col-md-12 title mt-2"style="max-height: 50px;" >
                    Cart Amendments
                  </div>
  
                    <div *ngIf="amendCartList.length!=0"  class="col-md-12 mt-3" style="overflow:auto">
                      <table class="styled-tables col-md-12">
                          <thead>
                            <tr >
                              <!-- Dynamic headers based on tableHeaders array -->
                              <th style="padding: 8px;  text-align: center;"> Id			</th>
                              <th style="padding: 8px;  text-align: center;">Reference Id</th>
                              <th style="padding: 8px;  text-align: center;">Generation Time		</th>
                              <th style="padding: 8px;  text-align: center;">Processed By		</th>	
                              <th style="padding: 8px;  text-align: center;">Type	</th>
                              <th style="padding: 8px;  text-align: center;">Booking Type	</th>
                              <th style="padding: 8px;  text-align: center;">Status/Approval		</th>
                              <th style="padding: 8px;  text-align: center;">Payment			</th>
                              <th style="padding: 8px;  text-align: center;">Action			</th>
  
  
  
                            </tr>
                          </thead>
                          <tbody>
                            <!-- Iterate through dynamic data rows -->
                            <tr *ngFor="let amend of amendCartList">
                              <!-- Display structured data -->
                              <td  style="padding: 8px;">{{amend?.uuId}}</td>
                              <td  style="padding: 8px;">{{amend?.refId}}</td>
                              <td  style="padding: 8px;">{{formatDate(amend?.genTs)}}</td>
                              <td  style="padding: 8px;">{{amend?.processedBy}}</td>
                              <td  style="padding: 8px;">{{amend?.type}}</td>
                              <td  style="padding: 8px;">{{amend?.bookingType==='A'?('Automation'):''}}</td>
                              <td  style="padding: 8px;">{{amend?.status==="C"?("PROCESSED"+'/'):amend?.status==="I"?("INITIATED"+'/'):''}}{{amend?.approvalStatus}}</td>
                              <td  style="padding: 8px;">{{amend?.payment}}</td>
                              <td  style="padding: 8px;" >
                                <button mat-flat-button *ngIf="amend.status==='I'" style="background-color:#4986E8;color:white;" (click)="onClickAmendPro(amend)">Process</button>
                                <button mat-flat-button *ngIf="amend.status==='C'" style="background-color:#9fb6dc;color:white;cursor: not-allowed;" >Process</button>
  
                              </td>
  
  
  
  
                            </tr>
                          </tbody>
                        </table>
  
  
              </div> 
  
              <div class="col-md-12 mt-4"  >
                <div  class="col-md-12 card"  >
  
                 <div  class="  mt-1 " style="padding: 10px; ">
                  
                   <div #reportingTags class="col-md-12 title"style="max-height: 45px;" >
                       Reporting Tags
                   </div>
  
                   <div class="col-md-12 " style="overflow-y:auto">
                    <span   *ngFor="let rmtags of passengerDetails(airData.hotelItineraries[0].orderPassengerDetails);let i=index">
                      <div style="padding: 4px;" style="text-align: left;" class="name-type mt-2">Adult {{i+1}}</div>
                       <table  class="styled-tables mt-3" style="margin: 0; padding: 0;width: 100%;">
                        <!-- <thead>
                          <tr >
   <th class="name-type">Name</th>
  <th class="name-type">Display Name</th>
  <th class="name-type">Value</th>
  <th class="name-type">Invoiceable</th>
  
                          </tr>
                        </thead> -->
  
                           <tbody>
                             <!-- Iterate through dynamic data rows -->
                            <ng-container *ngFor="let tags of rmtags?.rmTags?.rmTagsList">
                             <tr *ngIf="tags.fieldType!='F'" style="background-color: #f2f2f2;"  >
                               <!-- Display structured data -->
                              
                                <td   class="name-type" style="text-align: left;width: 150px;padding: 4px;">{{tags?.displayName||tags?.name}}  </td>
                                  <td   class="" style="text-align: left;padding: 4px;background-color: white;" >
                                    <span  *ngIf="tags.fieldType!='F'">
                                    {{tags.value}}
                                    </span>
                                    
                                    </td>
                                  </tr>
                                  <tr *ngIf="tags.fieldType==='F'&&tags.value!='NA'" style="background-color: #f2f2f2;"  >
                                    <!-- Display structured data -->
                                   
                                     <td   class="name-type" style="text-align: left;width: 150px;padding: 4px;">{{tags?.displayName||tags?.name}}  </td>
                                       <td   class="" style="text-align: left;padding: 4px;background-color: white;" >
                                        
                                         <span>
                                           <button *ngIf="tags.value&&tags.value!='NA'"  mat-flat-button  style="background-color:#4986E8;color:white; font-size: 17px;" (click)="downloadTags(tags.value)">Download</button>
                                         </span>
                                         </td>
                                       </tr>
                                </ng-container>
  
                             
                           </tbody>
                         </table>  
                        </span>
                      <div *ngIf="airData.rmApprovalUpload">
                        <span   *ngFor="let rmtags of passengerDetails(airData.hotelItineraries[0].orderPassengerDetails);let i=index">
                           <table *ngIf="i===0" class="styled-tables mt-3" style="margin: 0; padding: 0;width: 100%;">
                         
                               <tbody>
                                <ng-container  *ngFor="let tags of rmtags?.rmTags?.rmTagsList">
                                 <tr *ngIf="tags.fieldType==='F'" style="background-color: #f2f2f2;" >                                
                                    <td   class="name-type" style="text-align: left;width: 150px;padding: 4px;">{{tags?.displayName||tags?.name}}  </td>
                                      <td   class="" style="text-align: left;padding: 4px;background-color: white;" >
                                       
                                        <span >
                                          <button   mat-flat-button  style="background-color:#4986E8;color:white; font-size: 17px;" (click)="downloadTags(airData.rmApprovalUpload)">Download</button>
                                        </span>
                                        </td>
                                      </tr>
                                    </ng-container>
      
                                 
                               </tbody>
                             </table>  
                            </span>
                            </div>
  
  </div>
  
  
  
  
  
  
  </div>
  
  </div>
  
  <div #whatsapp class="col-md-12 title mt-2"style="max-height: 45px;" >
    WhatsApp Notifications
  </div>
  <table class="styled-tables ">
    <thead>
      <tr >
        <!-- Dynamic headers based on tableHeaders array -->
        <th style="padding: 8px;  text-align: center;">Recipient	</th>
        <th style="padding: 8px;  text-align: center;">Status</th>
        <th style="padding: 8px;  text-align: center;">Channel</th>
        <th style="padding: 8px;  text-align: center;">Creation Date	</th>
  
        
  
  
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let AppDetail of whatsAppData;let i=index">
      <!-- Iterate through dynamic data rows -->
      <tr >
        <!-- Display structured data -->
       
          <td class="" style="padding: 8px;">{{AppDetail?.recipient}}</td>
           <td class="" style="padding: 8px;">{{AppDetail?.responseData?.messages[0]?.message_status==='accepted'?('Send'):AppDetail?.responseData?.messages[0]?.message_status===null?('Pending'):'Failed'}}</td>
           <td class="" style="padding: 8px;">{{AppDetail?.channel}}</td>
           <td class="" style="padding: 8px;">{{AppDetail?.createdTs}}</td>
  
           
      </tr>
      <tr *ngIf="i < whatsAppData.length">
        <td colspan="5" style="text-align: left; padding-left: 4px;font-size: small;color: gray;">{{displayWEJSON(AppDetail?.requestData)}}</td>
        
      </tr>
    </ng-container>
     
    </tbody>
  </table>
  <div #email class="col-md-12 title mt-2"style="max-height: 45px;" >
    Email Notifications
  </div>
  <table class="styled-tables ">
    <thead>
      <tr >
        <!-- Dynamic headers based on tableHeaders array -->
        <th style="padding: 8px;  text-align: center;">Recipient	</th>
        <th style="padding: 8px;  text-align: center;">Status</th>
        <th style="padding: 8px;  text-align: center;">Channel</th>
        <th style="padding: 8px;  text-align: center;">Creation Date	</th>
  
        
  
  
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let AppDetail of emailData;let i=index">
      <!-- Iterate through dynamic data rows -->
      <tr >
        <!-- Display structured data -->
       
          <td class="" style="padding: 8px;">{{AppDetail?.recipient}}</td>
           <td class="" style="padding: 8px;">{{''}}</td>
           <td class="" style="padding: 8px;">{{AppDetail?.channel}}</td>
           <td class="" style="padding: 8px;">{{AppDetail?.createdTs}}</td>
  
           
      </tr>
      <tr *ngIf="i < emailData.length">
        <td colspan="5" style="text-align: left; padding-left: 4px;font-size: small;color: gray;"><pre [innerHTML]="AppDetail?.requestData"></pre></td>
        
      </tr>
    </ng-container>
     
    </tbody>
  </table>
  </div>
  
  
  
                      </div>
                     
                    </div>
                    </div>
                </div>
  
                <div class="modal " id="myMod"  [style.display]="showGSTPopup ? 'block' : 'none'" >
                  <div class="modal-dialog" >
                      <div class="modal-content " >
                          <div class="modal-header title">
                            <h4  class="modal-title">GST Details</h4>
  
                            <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                            </div>
                            <div class="modal-body">
                            <div class="col-md-12 mt-3 " *ngIf="showGSTPopup">
                              <div class="col-md-12 d-flex justify-content-center" >
                              <div class="col-md-12 row " >
                                  <div class=" col-md-12 " style="overflow: auto; max-height:60vh ;">
                                      <form [formGroup]="GstRegFg"   autocomplete="off"  class=" row" >
                                       
  
                                        <div class="col-md-12 title mb-2" style="max-height:45px">
                                          To GST Details
                                        </div>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label> To State	</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>To GST number		</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>To GST email			</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>To GST Name			</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>To GST Address			</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>To GST Phone		</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
  
                                        <div class="col-md-12 title mb-2" style="max-height:45px">
                                          From GST Details
                                        </div>
  
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>From State				</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>From GST number				</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>From GST Name			</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>From GST Address		</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>From GST Phone			</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
                                        <div class="col-md-12 title mb-2 " style="max-height:45px">
                                          Customer GST Details
                                        </div>
  
  
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>Customer State				</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>Customer GST number				</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>Customer GST email				</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>Customer GST Name				</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>Customer GST Address				</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>Customer GST Phone				</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" >
  
                                        </mat-form-field>
                                       <div class="col-md-12 " style="text-align: left;">
                                            <mat-label class="bold col-md-12">Information to be passed to the service provider?
                                            </mat-label>    
                                            
                                            <mat-selection-list  class="col-md-12 " [multiple]="false"  #PaymentType   style="text-align: left;">
                                              <mat-list-option    class="col-md-12 d-flex justify-content-start"   [color]="'primary'" checkboxPosition="before"><span  >From GST</span>
                                              </mat-list-option>
                                              <mat-list-option    class="col-md-12 d-flex justify-content-start"   [color]="'primary'" checkboxPosition="before"><span >To GST</span>
                                              </mat-list-option>
                                            <mat-list-option     class="col-md-12 d-flex justify-content-start"  [color]="'primary'" checkboxPosition="before"><span  >Customer GST</span>
                                            </mat-list-option>
                                            <mat-list-option    class="col-md-12 d-flex justify-content-start"  [color]="'primary'" checkboxPosition="before"><span  >None</span>
                                            </mat-list-option>
                                           
                                              </mat-selection-list>
                                            </div>
                                        </form>
                                  </div>
                                  </div>
                                  </div>                                      
                            </div>
  
                              <div class="modal-footer">
                               
                                <button  class="btn btn-outline-success c-width-100px shadow "   [disabled]="GstRegFg.invalid">Update</button>
  
                              <button  type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                         
                              </div>
                            </div>
                            </div>
                    </div>
                </div>
                <div *ngIf="showNewWhatsApp" class="popup-overlay" >
                 
                  <div class="popup-container">
                    <div class="modal-header ">
                      <h6  class="modal-title">WhatsApp Number</h6>
    
                      <button type="button" class="close" data-dismiss="modal" (click)="closedPopup()">&times;</button>
                      </div>
                    <input type="text" class="form-control" (input)="validateInput()" (keypress)="onlyNumberKey($event)" [(ngModel)]="WhatsAppNumber" minlength="10" maxlength="10" placeholder="Mobile No...">
                    <button  (click)="SendNewNo(WhatsAppNumber)"  class="btn btn-outline-success c-width-100px shadow mt-1" [disabled]="!isInputValid" >Send</button>
                  </div>
                </div>
  
  
                <div *ngIf="showNewEmail" class="popup-overlay" >
                 
                  <div class="popup-container">
                    <div class="modal-header ">
                      <h6  class="modal-title">Email Id</h6>
    
                      <button type="button" class="close" data-dismiss="modal" (click)="closedPopup()">&times;</button>
                      </div>
                    <input type="text" class="form-control"   [(ngModel)]="emailId"  placeholder="Email Id...">
                    <button  (click)="SendEmailNewNo(emailId)"  class="btn btn-outline-success c-width-100px shadow mt-1" [disabled]="!validateEmailInput(emailId)" >Send</button>
                  </div>
                </div>
  
  
  
  
                <div class="modal " id="myMod"  [style.display]="showAmend ? 'block' : 'none'" >
                  <div class="modal-dialog" >
                      <div class="modal-content " >
                          <div class="modal-header title">
                            <h4  class="modal-title">Amendment Remarks 
                              <!-- <small style="color: red;">(Cancellation will be processed for all the Passengers)</small> -->
                            </h4>
  
                            <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                            </div>
                            <div class="modal-body">
                            <div class="col-md-12 mt-3 mb-2 row" *ngIf="showAmend">
                        
                              <div class="col-md-5 bold d-flex justify-content-start">
                                Amendment Type:
                              </div>
                              <div class="col-md-6 d-flex justify-content-start">
                               {{amendmentType}}
                              </div>
  
                              <!-- <div class="col-md-5 mt-1 bold d-flex justify-content-start">
                                Sector:
                              </div>
                              <div class="col-md-6 d-flex justify-content-start">
                               <div  ><span>{{cityFilter(sector.fromAirport)}}</span><span style="padding-left: 5px; padding-right: 5px;">To</span><span>{{cityFilter(sectorlastflight)}}</span> <span *ngIf="flights?.flightDetails?.flightDetailsList[0]?.schDepartureTime" style="color: rgb(150, 144, 144);"> {{dateFormate(sector?.schDepartureTime)}}</span></div>
  
                              </div> -->
  
                              <div class="col-md-5 mt-1 bold d-flex justify-content-start">
                                Comment:
                              </div>
                              <div class="col-md-6">
                               <div  > <textarea  type="text" class="form-control" [(ngModel)]="comment"  rows="1"   name="description"  ></textarea>
                               </div>
  
                              </div>
                              <div class="col-md-5 mt-1 bold d-flex justify-content-start">
                                
                              </div>
                              <div class="col-md-6 d-flex justify-content-start mt-1 bold">
                              <input type="checkbox" style="width: 15px;height:15px;margin-top: 4px;"  [(ngModel)]="manualCancellation" > &nbsp; Manual Cancellation 
  
                              </div>
                              
                            </div>
                           
  
                              <div class="modal-footer">
                               
                                <button *ngIf="amendmentType==='Cancel'" class="btn btn-outline-success c-width-100px shadow " [disabled]="confirmDisabled" (click)="cancel()">Confirm Amendment</button>
                                <button *ngIf="amendmentType!='Cancel'" class="btn btn-outline-success c-width-100px shadow ">Confirm Amendment</button>
  
                              <button  type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                         
                              </div>
                              <mat-divider></mat-divider>
                              <span  class="d-flex justify-content-start"><p><strong>Note: </strong>Do you really want to amend? Please note these changes are irreversible and might take some time to process.</p></span>
  
                            </div>
                            </div>
                    </div>
                </div>
  
  
                <div class="modal " id="myMod"  [style.display]="showAmendProcess ? 'block' : 'none'" >
                  <div class="modal-dialog" >
                      <div class="modal-content " >
                          <div class="modal-header title">
                            <h4  class="modal-title">Amendment Items ({{AmendProcessDetail?.uuId}})
  
                            </h4>
  
                            <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                            </div>
                            <div class="modal-body" style="overflow: auto;max-height: 60vh;">
                            <div class="col-md-12 mt-3 mb-2 " *ngIf="showAmendProcess">
                        <!-- <div class="title col-md-12" style="max-height: 40px;text-align: left;padding-left: 6px;">{{AmendProcessDetail?.refId}}</div> -->
                        <table class="styled-tables ">
                          <thead>
                            <tr >
                              <!-- Dynamic headers based on tableHeaders array -->
                              <th style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> hotel</mat-icon>Room Type                                      
                                    <th *ngIf="airData?.hotelItineraries[0]?.hotelDetails?.hotel?.mmtRooms"  style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> restaurant</mat-icon>Meal Plan</th>

                              <th *ngIf="airData?.hotelItineraries[0]?.hotelDetails?.hotel?.expediaRooms"  style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> restaurant</mat-icon>Services</th>
                              <th style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> groups</mat-icon>Guest Name  </th>
                              
  
  
                            </tr>
                          </thead>
                          <tbody>
                            <!-- Iterate through dynamic data rows -->
                            <ng-container *ngFor="let room of amendAirItineraries;let i=index">

                            <tr >
                             
                              <td *ngIf="room?.hotelDetails?.hotel?.mmtRooms"  style="padding: 8px; text-align: center;">
                                {{ room?.hotelDetails?.hotel?.mmtRooms[0]?.name  }}
                              </td>
                              <td *ngIf="room?.hotelDetails?.hotel?.expediaRooms"  style="padding: 8px; text-align: center;">
                                {{ room?.hotelDetails?.hotel?.expediaRooms[0]?.room_name  }}
                              </td>
                              <td *ngIf="airData?.hotelItineraries[0].hotelDetails?.hotel?.mmtRooms" style="padding: 8px; text-align: center;">
                                {{ room?.hotelDetails?.hotel?.mmtRooms[0]?.ratePlans[0]?.description }}
                              </td>
                              <td *ngIf="airData?.hotelItineraries[0].hotelDetails?.hotel?.expediaRooms" style="padding: 8px; text-align: center;">
                                <ul style="text-align: start;" >
                                  <!-- style="list-style: none;" -->
                                  <li  *ngFor="let amen of  room?.hotelDetails?.hotel?.expediaRooms[0]?.rates[0].amenities let t = index"  [hidden]=" t >= 2"> 
                                    <!-- <mat-icon style="font-size: 18px;padding-top: 8px;"  *ngIf="amen.name==='Free WiFi'">wifi</mat-icon>
                                    <mat-icon style="font-size: 18px;padding-top: 8px;"  *ngIf="amen.name==='Free self parking'"> local_parking</mat-icon>
                                    <mat-icon style="font-size: 18px;padding-top: 8px;" *ngIf="amen.name==='Breakfast buffet'">free_breakfast</mat-icon>
                                    <mat-icon style="font-size: 18px;padding-top:8px;" *ngIf="amen.name==='Free one-way airport transfer'"> transfer_within_a_station</mat-icon>
                                    <mat-icon style="font-size: 18px;padding-top: 8px;" *ngIf="amen.name==='Free welcome drink'"> local_drink</mat-icon>
             -->
                                    {{ amen.name }}
            
                                  </li>
                                  <li style="list-style: none;" *ngIf="room?.hotelDetails?.hotel?.expediaRooms[0]?.rates[0]?.amenities&&room?.hotelDetails?.hotel?.expediaRooms[0]?.rates[0]?.amenities.length>2"><span  class="yes" style="cursor: pointer;" (click)="ameni.toggle($event)">...more</span></li>
            
                                  <p-overlayPanel #ameni [style]="{ width: '30rem' }">
                                    <li *ngFor="let amen of room?.hotelDetails?.hotel?.expediaRooms[0]?.rates[0].amenities "  > 
                                      {{ amen.name }}
                                    </li>
                                  </p-overlayPanel>

                                  </ul>                                         
                                 </td>
                              <td style="padding: 8px; text-align: center;">
                                <div *ngFor="let guest of room.orderPassengerDetails ">
                                  {{ guest?.title}}  {{ guest?.firstName}}  {{ guest?.lastName}} <br>
                                  <!-- {{'Adult'}} -->
                                  {{guest.type==="ADT"?("Adult"):guest.type==="CHD"?("Child"):guest.type==="INF"?("Infant"):''}}
                                  <mat-divider ></mat-divider>
                                </div>
                              </td>
                           
                            </tr>
                            <!-- <tr *ngIf="i < airData?.hotelItineraries.length">
                              <td colspan="3" style="text-align: left; padding-left: 4px; font-size: small;color: gray;"><strong>{{room.supplierPayment?('Supplier Payment:'):''}}</strong>{{displayWEJSON(room.supplierPayment)}}</td>
                            </tr> -->
                            </ng-container>
                            
                          </tbody>
                        </table>

                              <table class="styled-tables col-md-12" style="text-align: left;">
                                <thead>
                                  <tr >
                                    <!-- Dynamic headers based on tableHeaders array -->
                                    <th style="padding: 8px;  text-align: center;"></th>
                                    <th style="padding: 8px;  text-align: center;">Current Value	</th>
                                    <th style="padding: 8px;  text-align: center;">New Value</th>
                                   
        
        
                                  </tr>
                                </thead>
                                <tbody>
                                
                                  <tr>
                                    <td  style="padding: 8px;">{{'Reseller Amendment Fee'}}</td>
                                    <td  style="padding: 8px;">{{AmendProcessDetail?.amendmentCharges?.resellerCharges}}</td>
                                    <td  style="padding: 8px;">
                                      <input type="text" readonly class="form-control" name="resellerCharges" (keypress)="onlyNumberKey($event)" [(ngModel)]="PassengerDetail.resellerCharges"></td>
                                  </tr>
                                  <tr>
                                    <td  style="padding: 8px;">{{'Supplier Amendment Fee '}}</td>
                                    <td  style="padding: 8px;">{{'0'}}</td>
                                    <td  style="padding: 8px;">
                                      <input type="text" class="form-control" name="feeRules" (keypress)="onlyNumberKey($event)" [(ngModel)]="PassengerDetail.feeRules"></td>
                                  </tr>
                                  <tr>
                                    <td  style="padding: 8px;">{{'Supplier Amendment Fee Markup'}}</td>
                                    <td  style="padding: 8px;">{{'0'}}</td>
                                    <td  style="padding: 8px;">
                                      <input type="text" class="form-control" name="feeMarkup" (keypress)="onlyNumberKey($event)" [(ngModel)]="PassengerDetail.feeMarkup"></td>
                                  </tr>
                                 
                                
  
  
  
                                </tbody>
                              </table>
  
                              
  
                              <div class="title col-md-12 mt-2" style="max-height: 40px;text-align: left;padding-left: 6px;">{{'Amount Details'}}</div>
  
                              <table class="styled-tables ">
                                <thead>
                                </thead>
                                <tbody>
                                  <!-- Iterate through dynamic data rows -->
                                  <!-- <tr >
                                    <td  class="name-type" style="padding: 8px;width: 50%;">Refund TDS	</td>
                                    <td  style="padding: 8px;">{{''}}</td>
                                   
                                  </tr> -->
                                  <tr >
                                    <!-- Display structured data -->
                                    <td class="name-type"  style="padding: 8px;width: 50%;">Amendment Type	</td>
                                    <td  style="padding: 8px;">{{AmendProcessDetail?.type}}</td>
                                   
                                  </tr>
                                  <tr  class="mt-3">
                                    <!-- Display structured data -->
                                    <td class="name-type"  style="padding: 8px;">Amount To Charge	</td>
                                    <td  style="padding: 8px;">{{totalPrice(PassengerDetail.feeRules,PassengerDetail.feeMarkup)}}</td>
                                   
                                  </tr>
                                </tbody>
                              </table>
  
                              <!-- <div class="title col-md-12 mt-2" style="max-height: 40px;text-align: left;padding-left: 6px;">{{'Reseller Balance'}}</div> -->
  
                              <!-- <table class="styled-tables ">
                                <thead>
                                </thead>
                                <tbody>
                                  <tr >
                                    <td  class="name-type" style="padding: 8px;width: 50%;">Balance Amount	
                                    </td>
                                    <td  style="padding: 8px; " style="text-align: left;padding-left: 8px;">
                                      <div class="col-md-12">
                                      <strong>Your Balance: </strong>INR 0
                                    </div>
                                    <div class="col-md-12">
  
                                     <strong> Credit Balance:</strong> INR 0
                                     </div>
                                    </td>
                                   
                                  </tr>
                                  
                                </tbody>
                              </table> -->
                            </div>
                           
                          </div>
  
                              <div class="modal-footer">
                               
                                <button  class="btn btn-outline-success c-width-100px shadow " (click)="amendProcess()" [disabled]="disabled" >Amend</button>
  
                              <button  type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                         
                              </div>
                              
                            </div>
                    </div>
                </div>


                <p-dialog header="Update HCN " [(visible)]="display" [modal]="true" [closable]="true" [style]="{ width: '50rem' }">
                  <div class="p-fluid ">
                    <div class="col-md-12 mt-3" >
                      <div class="col-md-12 d-flex justify-content-start "><strong>&#x2714; Hotel Name : </strong> {{pnrData?.name}}</div>
                      <div  class="col-md-12 d-flex justify-content-start "><strong>&#x2714; Supplier Name : </strong> <span style="text-transform: uppercase;"> {{airData?.hotelSupplier}}</span></div>

                      <div class="col-md-12 d-flex justify-content-start "><strong>&#x2714; Supplier booking ref. number : </strong> {{airData?.bookingId}}</div>

                      
                      <div class="check-in-out">
                        <div class="check-in">
                            <span>&#x2714; Check in</span>
                            <span>{{airData?.hotelBooking?.hotelRequest?.checkInDate}}</span>
                        </div>
                        <div class="check-out">
                            <span>&#x2714; Check out</span>
                            <span>{{airData?.hotelBooking?.hotelRequest?.checkOutDate}}</span>
                        </div>
                        <div class="total-rooms">
                            <span>&#x2714; Total Rooms</span>
                            <span>{{airData?.hotelBooking?.hotelRequest?.roomCount}}</span>
                        </div>
                        <div class="total-stay">
                            <span>&#x2714; Total Stay</span>
                            <span>{{calculateStayNights(airData?.hotelBooking?.hotelRequest?.checkInDate,airData?.hotelBooking?.hotelRequest?.checkOutDate)}} </span>
                        </div>
                    </div>             
                      <table class="styled-tables "> 
                        <thead>
                          <tr >
                            <!-- Dynamic headers based on tableHeaders array -->
                            <th style="padding: 8px;  text-align: center;">&#x2714; Room Type
                            </th>
                            <th *ngIf="airData?.hotelItineraries[0]?.hotelDetails?.hotel?.mmtRooms" style="padding: 8px;  text-align: center;">&#x2714; Meal Plan</th>
                            <th *ngIf="airData?.hotelItineraries[0]?.hotelDetails?.hotel?.expediaRooms" style="padding: 8px;  text-align: center;">&#x2714; Services</th>

                            <th style="padding: 8px;  text-align: center;">&#x2714; Guest Name  </th>
                                  <!-- <th style="padding: 8px;  text-align: center;"  >Seat Map</th> -->
                            
                            <!-- <th *ngIf="!showSeatSelection"  style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" (click)="seatWindow()">Seat Selection </th>
                            <th *ngIf="showSeatSelection"  style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" > <div class="d-flex justify-content-end">Seat Selection  <mat-spinner class="mt-1"  diameter="15" ></mat-spinner></div></th> -->



                          </tr>
                        </thead>
                        <tbody>
                          <!-- Iterate through dynamic data rows -->

                          <tr *ngFor="let room of airData?.hotelItineraries">
                            
                            
                            <td *ngIf="room?.hotelDetails?.hotel?.mmtRooms"  style="padding: 8px; text-align: center;">
                              {{ room?.hotelDetails?.hotel?.mmtRooms[0]?.name  }}
                            </td>
                            <td *ngIf="room?.hotelDetails?.hotel?.expediaRooms"  style="padding: 8px; text-align: center;">
                              {{ room?.hotelDetails?.hotel?.expediaRooms[0]?.room_name  }}
                            </td>
                            <td *ngIf="airData?.hotelItineraries[0].hotelDetails?.hotel?.mmtRooms" style="padding: 8px; text-align: center;">
                              {{ room?.hotelDetails?.hotel?.mmtRooms[0]?.ratePlans[0]?.description }}
                            </td>
                            <td *ngIf="airData?.hotelItineraries[0].hotelDetails?.hotel?.expediaRooms" style="padding: 8px; text-align: center;">
                              <ul style="text-align: start;" >
                                <li style="list-style: none;" *ngFor="let amen of  room?.hotelDetails?.hotel?.expediaRooms[0]?.rates[0].amenities let t = index"  [hidden]=" t >= 2"> 
                                  <mat-icon style="font-size: 18px;padding-top: 8px;"  *ngIf="amen.name==='Free WiFi'">wifi</mat-icon>
                                  <mat-icon style="font-size: 18px;padding-top: 8px;"  *ngIf="amen.name==='Free self parking'"> local_parking</mat-icon>
                                  <mat-icon style="font-size: 18px;padding-top: 8px;" *ngIf="amen.name==='Breakfast buffet'">free_breakfast</mat-icon>
                                  <mat-icon style="font-size: 18px;padding-top:8px;" *ngIf="amen.name==='Free one-way airport transfer'"> transfer_within_a_station</mat-icon>
                                  <mat-icon style="font-size: 18px;padding-top: 8px;" *ngIf="amen.name==='Free welcome drink'"> local_drink</mat-icon>
          
                                  {{ amen.name }}
          
                                </li>
                                <li style="list-style: none;" *ngIf="room?.hotelDetails?.hotel?.expediaRooms[0]?.rates[0]?.amenities&&room?.hotelDetails?.hotel?.expediaRooms[0]?.rates[0]?.amenities.length>2"><span  class="yes" style="cursor: pointer;" (click)="ameni.toggle($event)">...more</span></li>
          
                                <p-overlayPanel #ameni [style]="{ width: '30rem' }">
                                  <li *ngFor="let amen of room?.hotelDetails?.hotel?.expediaRooms[0]?.rates[0].amenities "  > 
                                    {{ amen.name }}
                                  </li>
                                </p-overlayPanel>

                                </ul>                                         
                               </td>
                           
                            <td style="padding: 8px; text-align: center;">
                              <div *ngFor="let guest of room.orderPassengerDetails ">
                                {{ guest?.title}}  {{ guest?.firstName}}  {{ guest?.lastName}} <br>
                                <!-- {{'Adult'}} -->
                                {{guest.type==="ADT"?("Adult"):guest.type==="CHD"?("Child"):guest.type==="INF"?("Infant"):''}}
                                <mat-divider ></mat-divider>
                              </div>
                            </td>
                          </tr>
                          
                        </tbody>
                      </table>
  
  
              </div> 
              
              <div class="special-requests" style="text-align: start;">
                <h3>Special request(s)</h3>
                <!-- Add special requests here -->
                <ul>
                  <li *ngFor="let data of specialArray(airData?.specialRequest)">
                   {{data}}
                  </li></ul>
            </div>
                <div class="d-flex justify-content-start"> <mat-checkbox color="primary" [(ngModel)]="verifyHotelDetails.verifiedByStaff">Above points checked <span style="color: red;">*</span></mat-checkbox></div>
                   

                    <div class="d-flex justify-content-start"><mat-checkbox color="primary" [(ngModel)]="verifyHotelDetails.extraBedding">Extra bed (Triple occupancy booking)</mat-checkbox></div>
                    <div class="d-flex justify-content-start"><mat-checkbox color="primary" [(ngModel)]="verifyHotelDetails.hotelPrePayment">Pre-payment to hotel</mat-checkbox></div>
                
                    <div class="p-field">
                      <label for="bookingId">Confirmation ID <span style="color: red;">*</span></label>
                      <input id="bookingId" type="text" pInputText [(ngModel)]="bookingId"   placeholder="Enter Confirmation ID">
                    </div>
                    <div class="p-field">
                      <label for="guestName">Hotel Contact Person <span style="color: red;">*</span></label>
                      <input id="guestName" type="text" pInputText [(ngModel)]="guestName"  placeholder="Enter Person Name">
                    </div>
                    <div class="p-field">
                      <label for="guestContact">Hotel Contact Number <span style="color: red;">*</span></label>
                      <input id="guestContact" type="text" pInputText [(ngModel)]="guestContact" placeholder="Enter Contact Number">
                    </div>
                    <div class="p-field">
                      <label for="guestContact">Re-confirmation Date </label>
                      <input id="guestContact" type="text" pInputText readonly [(ngModel)]="guestConfirmationDate" >
                    </div>
                    
                  </div>
                  <ng-template pTemplate="footer">
                    <div class="p-field">
                      <button pButton type="button" label="Update" icon="pi pi-check" (click)="updateBooking()" [disabled]="disabledHcn()"></button>
                    </div>
                  </ng-template>
                </p-dialog>






                <div class="popup-overlay" *ngIf="showPopUp" >
                  <div class="popup-container" style="width: 60rem;">
                    <div class="col-md-12 row">
                      <div class="col-md-6 d-flex justify-content-start">
                      <h4 >Miscellaneous Data</h4>
                    </div>
                      <div class="col-md-6 d-flex justify-content-end"><button  type="button" class="close" data-dismiss="modal" (click)="closeMiscellaneous()">&times;</button>
                      </div>
                    </div>
                    <div class="col-md-12 row">
                      <mat-form-field *ngIf="showPopUp" class="col-md-6" appearance="outline">
                        <mat-label>Miscellaneous Data</mat-label>
                        <mat-select [formControl]="serviceControl" multiple (selectionChange)="onMultiSelect()">
                          <mat-option *ngFor="let service of serviceData" [value]="service">
                            {{ service.type }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <!-- <mat-form-field class="col-md-6" appearance="outline">
                        <mat-label>Ticket Number</mat-label>
                        <input matInput type="text"  name="ticket"  autocomplete="off" >
                      </mat-form-field> -->
                    </div>
                    <div class="col-md-12 row" style="height: 350px;overflow: auto;">
                    <div class="col-md-12" >
                      <!-- <strong class="pt-2 d-flex justify-content-start">{{i+1}}. {{itinerary.from}}-{{itinerary.to}} </strong> -->
  
                   
  <div class="col-md-12 d-flex justify-content-start">
                    <!-- <h5>Selected Miscellaneous</h5> -->
                  </div>
                    <table class="styled-table">
                      <!-- <thead>
                        <tr>
                          <th>Number</th>
                          <th>Code</th>
                          <th>Type</th>
                        </tr>
                      </thead> -->
                      <tbody>
                        <tr *ngFor="let service of selectedServices">
                          <td>
                            <span style="font-weight:500;font-size: 16px;">{{ service.type }}</span></td>
                          <td >
                            <!-- <mat-form-field  appearance="outline"> -->
                              <mat-label  class="col-md-12"> {{service.number}}	</mat-label>
  
                              <input *ngIf="service.code==='specialRequest'"  class="col-md-12" matInput type="text"   [(ngModel)]="miscellaneousRequest.specialRequest" >
                              
                           </td>
                          <!-- <td>
                              <mat-label *ngIf="service.number!='Ticket Number'" class="col-md-12"> Amount	</mat-label>
                              <input *ngIf="service.code==='specialRequest'" [readonly]="itinerary.seatUpdated" class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)"   >
                             
                          </td> -->
                          <td>
                            <!-- <mat-form-field  appearance="outline"> -->
                              <mat-label *ngIf="service.number!='Ticket Number'" class="col-md-12"> ID	</mat-label>
                              <input *ngIf="service.code==='specialRequest'"  class="col-md-12" matInput type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="miscellaneousRequest.specialRequestId"  >
  
                            
                              <!-- </mat-form-field> -->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- ||selectedServices.length===0 -->
                    <button  class="save-button" mat-raised-button color="primary" (click)="updateMiscellaneous()" [disabled]="disabledMiscellaneous">Save</button>
                  </div>
                </div>
                <p-dialog header="Invoice" [modal]="true" [maximizable]="true" [(visible)]="pdfUrl" [style]="{ width: '55rem',height:'100%'  }">
                  <iframe *ngIf="pdfUrl" [src]="pdfUrl" width="100%" height="700px" ></iframe>
            </p-dialog>